let flyTimerId;
const flyDebounce = (fn, delay) => {
    clearTimeout(flyTimerId);
    flyTimerId = setTimeout(fn, delay);
}
const addedMasks = [];
const addMasks = (parent, selector = '.js-input-tel', maskType = 'phone') => {
    const masks = parent.querySelectorAll(selector);
    masks.forEach((elem) => {
        const ind = addedMasks.findIndex(([e]) => e === elem);
        if (ind === -1) {
            return;
        }
        const [, mask, listeners] = addedMasks[ind];
        mask.destroy();
        Object.entries(listeners).forEach(([event, listener]) => elem.removeEventListener(event, listener));
        addedMasks.splice(ind, 1);
    });
    const added = [];
    masks.forEach((elem) => {
        const optsByType = {
            phone: {
                mask: '+{7}(f00)000-00-00',
                definitions: {
                    'f': /[1-69]/
                },
            },
            date: {
                mask: Date
            }
        }
        const opts = optsByType[maskType] ?? optsByType.phone;
        const masked = IMask.createMask(opts);
        const mask = IMask(
            elem,
            {
                ...{
                    lazy: true,
                    //overwrite: true,
                },
                ...opts
            },
        );
        mask.on('accept', () => {
            mask.value = masked.resolve(mask.value);
        });
        const listenersByType = {
            phone: {
                focus: () => {
                    mask.updateOptions({ lazy: false });
                },
                blur: () => {
                    if (!mask.masked.isComplete) {
                        mask.value = '';
                    }
                    mask.updateOptions({ lazy: true });
                },
                input: (e) => {
                    if (mask._changingCursorPos === 16 && !mask.masked.isComplete) {
                        mask.value = masked.resolve(`${mask.value}${e.data}`);
                    }
                },
            },
            date: {
                focus: () => {
                    mask.updateOptions({ lazy: false });
                },
                blur: () => {
                    if (!mask.masked.isComplete) {
                        mask.value = '';
                    }
                    mask.updateOptions({ lazy: true });
                }
            }
        };
        const listeners = listenersByType[maskType] ?? listenersByType.phone;
        if (maskType === 'phone') {
            elem.placeholder = '+7(___) ___-__-__';
        }
        Object.entries(listeners).forEach(([event, listener]) => {
            elem.addEventListener(event, listener)
        });
        addedMasks.push([elem, mask, listeners]);
        added.push(elem);
    });
    return added;
}
window.addMasks = addMasks;
window.addedMasks = addedMasks;

window.placeholderChanger = (selector = '', placeholders = []) => {
    let currentId = null;
    if (placeholders.length === 0) {
        return;
    }
    setInterval(() => {
        if (currentId === null) {
            currentId = 0;
        } else {
            currentId = (currentId + 1) % placeholders.length;
        }
        $(selector).attr('placeholder', placeholders[currentId]);
    }, 1000);
}

document.addEventListener('DOMContentLoaded', () => {
    window.addMasks(document);
    window.placeholderChanger(
        '.js-searchform-input',
        [
            'PlayStation 5',
            'Ноутбук I3',
            'Пылесос Karcher',
            'Беговая дорожка',
            'Велотренажер',
            'Проектор',
        ],
    );
    const domainElement = document.querySelector('.popup.popup-fast-order');
    const domain = domainElement.dataset.url;
    const domainOpen = domainElement.dataset.urlOpen;
    window.addEventListener('message', (event) => {
        if (event.origin.startsWith(domain)) {
            if (event.data?.action === 'close') {
                const $this = $('.popup.popup-fast-order');
                $this.fadeOut(400, function () {
                    $('body').removeClass('is-popup-open');
                });
                window.location.hash = '';
                return;
            }
            if (event.data?.action === 'hash' && event.data?.value) {
                window.location.hash = event.data?.value;
                return;
            }
        }
    });
    const body = document.querySelector('body');
    //if (width < 768) {
        $(document).on('click', '.js-popup-cart, .menu-bottom-fixed__item.cart, .ya_gotocart', function(e) {
            e.preventDefault();
            if ($('body').hasClass('is-open')) {
                return;
            }
            $('.popup-fast-order .popup__inner').html(`<iframe src="${domainOpen}" width="100%" height="100%" style="border:0;height:100dvh">`);
            const iframe = $('.popup-fast-order .popup__inner').find('iframe');
            const domainElement = document.querySelector('.popup.popup-fast-order');
            const token = domainElement.dataset.token;
            if (token) {
                iframe.on('load', () => {
                    setTimeout(() => iframe[0].contentWindow.postMessage({ action: 'token', value: token }, '*'), 500);
                });
            }
            $('.js-popup-fast-cart-btn').click();
            $('body').addClass('checkout');
        });
    //}
});

var no_async = 0;
var width = Math.max($(window).width(), window.innerWidth);
var height = window.innerHeight;
window.datepicker = [];
var timeslider = [];

$(window).on('load', load);
$(document).ready(document_ready);


function grid_days_select_click() {
    //$(this).addClass('is-active').siblings().removeClass('is-active');
    $(this).parents('.add_cart_form').find('.grid_price').html($(this).find('.grid_price_example').val());
    //console.log($(this).find('.grid_date_range_example').html());
    $(this).parents('.add_cart_form').find('.datepicker__data').html($(this).find('.grid_date_range_example').html());
    $(this).parents('.add_cart_form').find('.date_end').val($(this).find('.grid_date_end_example').val());
    check_sub_type_button(this);
    window.update_cart_form($(this).parents('.add_cart_form').find('.date_start'));
}

function grid_subs_select_click() {
    $(this).addClass('is-active').siblings().removeClass('is-active');
    $(this).parents('.add_cart_form').find('.grid_price').html($(this).find('.grid_price_example').val());

    var timeslider_id = $(this).parents('.add_cart_form').find('.item_id').val();
    timeslider['time_slider_'+timeslider_id].set($(this).find('.grid_month_example').val());
    $(this).parents('.add_cart_form').find('.period.amount_field').val($(this).find('.grid_month_example').val());
    check_sub_type_button(this);
    window.update_cart_form($(this).parents('.add_cart_form').find('.period.amount_field'));
}

function add_cart_form_submit() {
    return add_to_cart(this);
}

function add_cart_link_click() {
    return add_to_cart($(this).parents('.add_cart_form'));
}


function document_ready () {
    $('body').on('click', '.grid-days-select', grid_days_select_click);

    $('body').on('click', '.grid-subs-select', grid_subs_select_click);

    $('.add_cart_form').on('submit', add_cart_form_submit);
    $('.add_cart_link').on('click', add_cart_link_click);

    $('.no_first_show:not(.no_show)').removeClass('nod');
    $('body').on('click', '.popup-city__nav .checkout-radio__input', function(e) {
        const current = $(this).closest('form').data('current');
        if ($(this).val() == current) {
            $('#popup-2city').find('.js-popup-close').trigger('click');
            return;
        }
        $.ajax({
            url: '/city/',
            type: 'post',
            data: { city_id: $(this).val(), from: document.location.pathname },
            dataType: 'json',
            complete: function (data) {
                if (data.status !== 200) {
                    return;
                }
                try {
                    res = $.parseJSON(data.responseText);
                } catch (err) {
                    res = { link: '/' };
                }
                if (!res.link) {
                    return;
                }
                document.location = res.link;
            },
            cache: false,
            async: true,
        })
    });
    // больше не учитывает реальное значение minDays
    $.dateRangePickerLanguages['ru']['more-than'] = 'Аренда минимум 2 дня';
    $.dateRangePickerLanguages['ru']['default-more'] = 'Аренда минимум 2 дня';
}

function load()
{

    $('body').off('click', '.grid-days-select', grid_days_select_click).on('click', '.grid-days-select', grid_days_select_click);

    $('body').off('click', '.grid-subs-select', grid_subs_select_click).on('click', '.grid-subs-select', grid_subs_select_click);

    $('.add_cart_form').off('submit').on('submit', add_cart_form_submit);
    $('.add_cart_link').off('click').on('click', add_cart_link_click);

    let timerId;
    const debounce = (fn, delay) => {
        clearTimeout(timerId);
        timerId  =  setTimeout(fn, delay);
    }
    window.completedFastOrderPhone = () => debounce(() => $.ajax({
        url: '/cart/save/',
        type: 'post',
        data: { 'profile[phone]': $('.popup-fast-order__form .js-input-tel').val() },
        dataType: 'json',
        beforeSend: () => {
            $('.popup-fast-order__form .js-input-name').prop('disabled', true);
        },
        complete: function (data) {
            $('.popup-fast-order__form .js-input-name').prop('disabled', false);
            if (data.status === 200) {
                try {
                    res = $.parseJSON(data.responseText);
                } catch (err) {
                    res = { result: 1, message: 'Данные отправлены' };
                }
                if (res.phoneSaved) {
                    const noop = () => {};
                    const ymWrapper = ym || noop;
                    ymWrapper(51068642,'reachGoal','cart-phone');
                }
            }
        },
        cache: false,
        async: true,
    }), 200);

    window.completedFastOrderName = () => debounce(() => $.ajax({
        url: '/cart/save/',
        type: 'post',
        data: { 'profile[firstname]': $('.popup-fast-order__form .js-input-name').val() },
        dataType: 'json',
        beforeSend: () => {
            $('.popup-fast-order__form .js-input-tel').prop('disabled', true);
        },
        complete: function (data) {
            $('.popup-fast-order__form .js-input-tel').prop('disabled', false);
            if (data.status === 200) {
                try {
                    res = $.parseJSON(data.responseText);
                } catch (err) {
                    res = { result: 1, message: 'Данные отправлены' };
                }
            }
        },
        cache: false,
        async: true,
    }), 200);

    $('.js-tariff-more-open').on('click', () => {
        $('.product-tariff__option').removeClass('is-active');
        $('.product-tariff').removeClass('has-active');
        $('.product-simple__tariffs').addClass('_hidden-tariff-view');
    });

    $('.js-tariff-more-close').on('click', () => {
        $('.product-simple__tariffs').removeClass('_hidden-tariff-view');
        $('.product-tariff__option').removeClass('is-active');
        $('.product-tariff').removeClass('has-active');
    });

    $('.no_first_show:not(.no_show)').removeClass('nod');



    $('body').on('click', '.pp__info', function() {
        $(this).find('.pp__info-content').toggle();
    });

    $('body').on('mouseover', '.product-tariff__option', function() {
        //$('.product-tariff__option').removeClass('is-active');
        //$('.product-tariff__btn').addClass('nod');
        //$(this).addClass('is-active').find('.product-tariff__btn').removeClass('nod');;

    });

    if(window.location.hash.length > 0) {
        if(window.location.hash.indexOf("review") > -1) {
            if(Math.max($(window).width(), window.innerWidth) > 600){
                $('.js-tab-link[href="#reviews"]').trigger('click');

                $('html, body').stop().animate({
                    scrollTop: $(window.location.hash).offset().top
                }, 450, 'easeOutQuad');
            }else{
                $('.js-tab-header[href="#reviews"]').trigger('click');
            }

        }
    }

    $('.js-faq-more').on('click', function() {
        $(this).hide().closest('.faq__section').find('.faq__i:hidden').show();
    });

    set_search_events();
    check_favorite();
    $('.category-menu__list .has-dd').unbind('mouseenter');
    $('.category-menu__list .has-dd').unbind('mouseleave');
    $('.dd-menu__li.has-child').unbind('mouseenter');
    $('.dd-menu__li.has-child').unbind('mouseleave');
    $('body').on('mouseenter', '.category-menu__list .has-dd', function () {
        var childMenu = $('.dd-menu__childbox').eq(0);
        $(this).find('.dd-menu').stop(true).fadeIn(150);
        childMenu.show();
        $('.dd-menu').height(childMenu.outerHeight());
        $(this).addClass('is-open');
    });

    $('body').on('mouseleave', '.category-menu__list .has-dd', function () {
        $(this).find('.dd-menu').stop(true).fadeOut(150);
        $(this).removeClass('is-open');
    });

    $('body').on('mouseenter', '.dd-menu__li.has-child', function () {
        var childMenu = $(this).find('.dd-menu__childbox');
        $(this).siblings().find('.dd-menu__childbox').hide();
        childMenu.stop(true).show();
        $(this).addClass('is-open');
        $('.dd-menu').height(childMenu.outerHeight());
        if(childMenu.hasClass('has-1col')){}
    });

    $('body').on('mouseleave', '.dd-menu__li.has-child', function () {
        $(this).find('.dd-menu__childbox').stop(true).hide();
        $(this).removeClass('is-open');
        $('.dd-menu').height('auto');
        $('.dd-menu').width(960);
    });



    $('body').on('click', '.arenter-tarif__radio-desc', function() {
        $(this).parents('.add_cart_form').find('.period.amount_field').val($(this).parent().find('input').val());
        check_sub_type_button(this);
        window.update_cart_form($(this).parents('.add_cart_form').find('.period.amount_field'));
    });


    $('body').on('click', '.check_sub_type_button', function() {$('.full_price_wrapper').removeClass('nod');check_sub_type_button(this);});
    $('body').on('change', '.amount_field', function() {return window.update_cart_form(this);});
    $('body').on('click', '.favorite_button', function() {return check_favorite(this);});
    $('body').on('submit', '.no_only_iqos_in_cart', function() {show_popup($('#popup-no-rent-iqos'));return false;});
    $('body').on('input', '.only_digit_elem', function() {only_digit_elem(this);});
    $('body').on('change', '.selectstyle', function() {$(this).parent().find('.select-styled').removeClass('is-error');});
    $('body').on('click', '.infoblock-close', function() {check_header_infoblock(this);});

//	$('body').on('keyup focus click', '.dadata', function(event) {set_suggest(this, event);});
//	$('body').on('focus, keyup', '.dadata', function() {get_suggest(this);});


    $('body').on('submit', '#registration_form', function(ev) {
        $(this).append('<input type="hidden" name="haron" value="'+$('#haron').text()+'">');
        return true;
    });
    $('body').on('input', '.only_rus', function() {only_rus_elem(this);});
    $('body').on('click', '.catalog-popup__menu-link.has-ajax-child, .catalog-popup__submenu-link.has-ajax-child', function(e) {show_category_child(this);});

    $('body').on('mouseover', '.header__rmenu-user', function() {$('.header__rmenu-user .header__user-menu').show();});
    $('body').on('mouseleave', '.header__rmenu-user', function() {$('.header__rmenu-user .header__user-menu').hide();});

    $('body').on('mousemove', '.product_list_image_wrapper',function(e) {show_product_image(e, this);});

    $('body').on('click', '.ya_sendmessage',function() {return ya_reach_goal('sendmessage');});
    $('body').on('click', '.ya_callback', function() {return ya_reach_goal('callback');});
    $('body').on('click', '.ya_emailsignup', function() {return ya_reach_goal('emailsignup');});
    $('body').on('click', '.showroom__contact-r .ya_sendmessagecontacts', function() {return ya_reach_goal('sendmessagecontacts');});
    $('body').on('click', '.ya_rentfromcatalogue', function() {return ya_reach_goal('rentfromcatalogue');});
//	$('body').on('click', '.ya_rentfromitem', function() {return ya_reach_goal('rentfromitem');});
    $('body').on('click', '.ya_subscribefromcatalogue', function() {return ya_reach_goal('subscribefromcatalogue');});
//	$('body').on('click', '.ya_subscribefromitem', function() {return ya_reach_goal('subscribefromitem');});
//	$('body').on('click', '.ya_rentcomlexitem', function() {});
    $('body').on('click', '.ya_rentfromcart', function() {return ya_reach_goal('rentfromcart');});
    $('body').on('click', '.ya_gotocart', function() {return ya_reach_goal('gotocart');});
    $('.select_profile_order_type').change();
    $('body').on('change', '.select_profile_order_type', function() {
        if ($(this).val() == 'all')
        {
            $('.profile_order_item_wrapper').removeClass('nod');
            //$('.profile_order_ended').addClass('nod');
        }
        if ($(this).val() != 'all')
        {
            $('.profile_order_item_wrapper').addClass('nod');
            $('.profile_order_'+$(this).val()).removeClass('nod');
        }
    });

    $('body').on('click', '.profile_order_type', function() {
        $('.profile_order_type').each(function () {$(this).parents('li').removeClass('is-active');});
        $(this).parents('li').addClass('is-active');

        $('.profile_order_item_wrapper').addClass('nod');
        if ($(this).hasClass('ended'))
        {
            $('.select_profile_order_type_wrapper').addClass('nod');
            $('.profile_order_item_wrapper').each(function() {
                if ($(this).hasClass('profile_order_ended')) {$(this).removeClass('nod');}
            });
        }
        if (!$(this).hasClass('ended')) {
            $('.select_profile_order_type_wrapper').removeClass('nod');

            $('.profile_order_item_wrapper').each(function() {
                if (!$(this).hasClass('profile_order_ended')) {$(this).removeClass('nod');}
            });
            $('.select_profile_order_type').change();
        }
        return false;
    });

    $('.need_change_password').click();
    /* перенесено в marketing_services */
    if ($('.ecom_products').html())
    {
        /*
        try {
        detail_obj = new Object;
        detail_obj.ecommerce = new Object;
        detail_obj.ecommerce.currencyCode = "RUB";
        detail_obj.ecommerce.detail = new Object;
        detail_obj.ecommerce.detail.products = new Array()
        detail_obj.ecommerce.detail.products[0] = eval( '('+$('.ecom_products').html()+')' );

        ya_dataLayer.push(detail_obj);
        //console.log('просмотр карточки');
        //console.log(detail_obj);

        } catch (err) {}
        */
    }

    ancor = function () {
        var offset = $($(this).attr("href")).offset();
        $("body, html").animate({"scrollTop":offset.top},'slow');
        return false;
    }


    //$('a[href^="#"]').bind('click', ancor);
    $('.complect_product_list_wrapper').removeClass('nod');
    $('body').on('click', '.remove_from_cart', function() {return remove_from_cart(this);});
    $('body').on('click', '.inputbox--check', function() {check_field($(this).find('input[type="checkbox"]'), 1);});
    $('.selectstyle').each(function() {set_select_trigger(this);});

    $('body').on('click', '.payment_type_button', function() {return window.update_cart_item(this);});
    $('body').on('change', '.cart_delivery_change', function() {return window.update_cart_item(this);});
    $('body').on('submit', 'form.common_search_form', function() {return check_common_search_form($('#'+$(this).attr('id')), 1);});

    $('body').on('click', '.search_field', function() {return check_search_field(this);})
    $('body').on('change', '.search_change_field', function() {return check_search_field(this);})

    $('[data-type="mts-dalee"]').on('click', () => {
        dataLayer.push({
            'event': 'vntArent',
            'eventCategory': 'arenter',
            'eventAction': 'button_click',
            'eventLabel': 'dalee',
            'eventValue': Number($('.cart_all_sum').text().replace(/[^\d]/gi,'')),
            //'screenName': document.location.pathname, // а есть маппинг наших товаров в урл мтс?
            'eventContent': 'step_2',
            'eventContext': $('.amount_field').val(),
            'buttonLocation': 'popup',
            'actionGroup': 'interactions',
            'productName': $('.product_name').text(),
            'productId': $('.mts_product_id').val()
        });
    });
    $('[data-type="kant-dalee"]').on('click', () => {

    });
    $('[data-type="mts-passport-dalee"]').on('click', () => {
        dataLayer.push({
            'event': 'vntArent',
            'eventCategory' : 'arenter',
            'eventAction' : 'button_click',
            'eventLabel' : 'dalee',
            'eventValue': Number($('.cart_all_sum').text().replace(/[^\d]/gi,'')),
            //'screenName': document.location.pathname, // а есть маппинг наших товаров в урл мтс?
            'eventContent': 'step_3',
            'eventContext': $('.mts_period').val(),
            'buttonLocation': 'popup',
            'actionGroup': 'interactions',
            'productName': $('.product_name').text(),
            'productId': $('.mts_id').val(),
        });
    })
    $('form.need_check_form').each(function() {check_form($('#'+$(this).attr('id')),0);});
    $(document).on('submit', 'form.need_check_form', function (e) {
        return check_form($('#' + $(this).attr('id')), 1);
    });
    // после загрузки js уберем тип кнопки submit, чтобы не выполнять двойную отправку формы
    $('form.need_check_form .order_button').each(function () {
        $(this).attr('type', 'button');
    });
    $('body').on('click', 'form.need_check_form .order_button[type="button"]', (e) => {
        const form = $(e.target).closest('form');
        // отправка (вызов submit формы) будет произведена внутри функции после успешного завершения асинхронного запроса к /cart/register/
        $(form).submit();
    });
    $('body').on('focus', '.need_field', function() {window.ready_field(this);});
    $('body').on('click', '.result_marker', function() {window.ready_field(this);});
    $('form.need_check_form .check_field').parent().find('.select-styled').on('click', function() {window.ready_field($(this).parent().find('.check_field'));});
    $('body').on('onblur', 'form.need_check_form .check_field', function() {check_field(this);});
    $('body').on('focus', 'form.need_check_form .check_field', function() {window.ready_field(this);});

    $('body').on('click', '.del_search_item', function() {del_search_item(this);});
    $('body').on('click', '.filter_reset_button', function() {clear_search_filter(this);});

    $('body').on('click', '.filter_form_button', function() {$(this).parents('#common_search_form').submit();});
    $('body').on('change', '#filter_brand', function() {change_filter_brand(this);});
    $('body').on('change', '.filter_category', function() {change_filter_category(this);});
    $('body').on('change', '.filter_order', function() {change_filter_order();});
    //$('body').on('click', '.catalog_mob_sort', function() {change_filter_order(1);});
    $('body').on('change', '.form_file', function() {show_upload_preview(this);});
    $('body').on('click', '.add_file_button', function() {$(this).parents('form').find('.form_file').click();});
    $('body').on('click', '.card_delete_link', function() {set_card_popup(this);});
    //$('body').on('click', '.cart_item_list .qty-box__action', function() {$(this).parent().find('.amount_field').trigger('change');});
    $('body').on('change', '.cart_item_list .amount_field', function() {window.update_cart_item(this);});
    $('body').on('change', '.cart_item_list .sub_amount_field', function() {window.update_cart_item(this);});

    $('.js-qty-plus').unbind('click');
    $('body').on('click', '.js-qty-minus', function() {
        var inputbox = $(this).parent().children(".qty-box__input");
        var value = inputbox.val();
        var res = Math.max(parseInt(value) - 1, 1);
        inputbox.val(res).change();
    });

    $('.js-qty-minus').unbind('click');
    $('body').on('click', '.js-qty-plus', function() {
        var inputbox = $(this).parent().children(".qty-box__input");
        var value = inputbox.val();
        var res = parseInt(value) + 1;
        inputbox.val(res).change();
    });


    $('#cart_address_list').on('submit', function() {return set_cart_address(this);});
    $('body').on('click', '.cart_param_list', function() {return set_cart_param(this);});
    $('body').on('click', '.cart_pvz_list', function() {return set_cart_param(this);});
    $('.profile_preview_del').on('click', function() {$('#del_avatar').val('1');$(this).parent().remove();});
    $('.feature_value').on('click', function() {check_filter_search(this);});
    $('body').on('click', '.activation_mail_button',function() {send_mail_activation_mail(this);});
    $('body').on('click', '.activation_mail_code_button', function() {send_mail_activation_code(this);});
    $('body').on('click', '.activation_phone_button', function() {send_phone_activation_code(this);});
    $('body').on('click', '.check_phone_button', function() {check_phone_activation_code(this);});
    $('body').on('input', '.check_phone_field', function() {
        var val = $(this).val();
        //console.log(val);
        if (val.length == 6) {$(this).parents('.inputbox').find('.check_phone_button').click();}

    });

    $('body').on('focus', '.check_phone_field', function() {window.ready_field(this);});
    $('body').on('click', '.check_card_button', function() {check_card(this);});
    $('body').on('focus', '.check_card_field', function() {window.ready_field(this);});
    $('body').on('click', '.on_page_select', function() {set_on_page(this);});
    $('.order_column').on('click', function() {set_order_value(this);});
    $('.profile_order_date').on('change', function() {set_search_date(this);});
    $('.change_sub_product').on('click', function() {change_sub_product(this);});
    $('.complect_product_list').on('click', function() {product_in_complect(this);});

    $('body').on('submit', '.review-form', function() {review_save(this);});
    //$('body').on('focus', '.js-input-tel', function() {check_phone_mask(this);});

    $('.cart_payment_form').on('submit', function() {
        //$(this).find('.field_wrapper').addClass('nod');
        //$(this).find('.loader').removeClass('nod');
        //setTimeout(function () {$('.cart_payment_form').find('.loader').addClass('nod');}, 3000);
    });
    $('.date_visible').on('focus', function() {$(this).parents('.date_wrapper').removeClass('is-error');});
    $('.js-tarif-cont-toggle').on('click', function(e) {
        e.preventDefault();
        var btn = $(this);
        var id = btn.attr('href');
        var offset = btn.offset();
        btn.toggleClass('is-open');
        if(Math.max($(window).width(), window.innerWidth) > 450)
        {
            var top = offset.top + btn.outerHeight() + 2;
            var left = offset.left - 355 + btn.outerWidth();
        } else {
            var top = offset.top + btn.outerHeight() + 2;
            var left = 12;
        }
        $(id).css({top:top,left:left});
        $(id).fadeToggle(200);
    });

    // $('.add_cart_form').on('submit', function() {return add_to_cart(this);});
    // $('.add_cart_link').on('click', function() {return add_to_cart($(this).parents('.add_cart_form'));});

    //$('body').on('click', '.datepicker', function() {$(this).find('.date-range').trigger('open');});
    //$('body').on('open', '.date-range', function() {$(this).click();});

    $('body').on('click', '.date-range', function(e){
        $(this).removeClass("is-error")
        if ($(this).hasClass("is-open"))
        {
            e.stopPropagation();
            //$(this).data('dateRangePicker').close();
        }
    });

    moment.locale('ru');
    window.set_range_picker_all();

    $('.time-slider').each(function () {window.set_time_slider(this);});
    $('.js-popup-link.new_popup').unbind('click');
    $('body').on('click', '.js-popup-link.new_popup', check_popup);

    $('.common_phone').each(function() {
        var phone = $(this).html();
        phone = phone.replace(/[^0-9]/gi, "");
        $(this).parents('a').attr('href', 'tel:+'+phone);

    });

    $('.js-auto-cat-link').on('click', function(e){
        e.preventDefault();
        $('.js-auto-cat-link').not(this).parent().removeClass('is-current');
        $(this).parent().addClass('is-current');

        if(width <= 600){
            var scrollLeft = $(this).position().left + $('.auto-cat__nav-scroller').scrollLeft();
            var widthItem = $(this).outerWidth();
            $('.auto-cat__nav-scroller').animate({
                scrollLeft: scrollLeft - width/2 + widthItem/2
            }, 400);
        }
        $.ajax({
            url: '/',
            success: function(data){
                var productList = $('.car-grid__row').html();
                $('.car-grid__row').html(productList);
            }
        });
    });

    // $('.no_first_show:not(.no_show)').removeClass('nod');

    var after_scoring = getCookie('after_scoring');
    if (after_scoring == 1) {$('.after_scoring').removeClass('nod');}
    delCookie('after_scoring');
    check_order_sub_products();

    $('.review-text').val(getCookie('review_text'));



    $('body').on('click', 'a.link_catalog', function() {

        var mpush  = new Object;
        mpush.event = 'Arenter';
        mpush.eventCategory = 'Сatalog';
        mpush.eventAction = $(this).text();
        if (mpush.eventAction == '') {mpush.eventAction = $(this).attr('href');}

        mpush.eventAction = mpush.eventAction.trim();
        mpush.eventLabel = document.location.href;

        dataLayer.push(mpush);
        return true;
    });

    $('body').on('click', 'a.link_news', function() {

        var mpush  = new Object;
        mpush.event = 'Arenter';
        mpush.eventCategory = 'Content';
        mpush.eventAction = $(this).text();
        if ($(this).hasClass('image')) {mpush.eventAction =  $(this).find('img').attr('alt');}
        if (mpush.eventAction == '') {mpush.eventAction =  $(this).attr('href');}
        mpush.eventLabel = $(this).attr('href');
        dataLayer.push(mpush);
        return true;
    });


    $('body').on('click', 'a.link_review', function() {

        var mpush  = new Object;
        mpush.event = 'Arenter';
        mpush.eventCategory = 'Content';
        mpush.eventAction = $(this).find('.review__name').text();
        mpush.eventLabel = $(this).attr('href');
        mpush.eventAction = mpush.eventAction.trim();
        dataLayer.push(mpush);
        return true;
    });

    $('body').on('click', '.mp__about-video a', function() {
        var mpush  = new Object;
        mpush.event = 'Arenter';
        mpush.eventCategory = 'Content';
        mpush.eventAction = $(this).find('img').attr('alt');
        if (mpush.eventAction == '') {mpush.eventAction =  $(this).attr('href');}
        mpush.eventLabel = document.location.href;
        mpush.eventAction = mpush.eventAction.trim();
        dataLayer.push(mpush);
        return true;
    });

    $('body').on('click', 'a.link_type', function() {

        var mpush  = new Object;
        mpush.event = 'Arenter';
        mpush.eventCategory = '';
        if ($(this).hasClass('arenda')) {mpush.eventCategory = 'Посуточная аренда';}
        if ($(this).hasClass('complect')) {mpush.eventCategory = 'Готовый комплект';}
        if ($(this).hasClass('sub')) {mpush.eventCategory = 'Ежемесячная подписка';}
        mpush.eventAction = $('h1').text();
        mpush.eventAction = mpush.eventAction.trim();
        mpush.eventLabel = $('h1').text();
        dataLayer.push(mpush);
        return true;
    });



    $('body').on('click', 'a.link_brand', function() {

        var mpush  = new Object;
        mpush.event = 'Arenter';
        mpush.eventCategory = 'Content';
        mpush.eventAction = $(this).text();
        if ($(this).hasClass('image')) {mpush.eventAction = $(this).find('img').attr('alt');}
        if (mpush.eventAction == '') {mpush.eventAction =  $(this).attr('href');}
        mpush.eventLabel = $(this).attr('href');
        mpush.eventAction = mpush.eventAction.trim();
        dataLayer.push(mpush);
        return true;
    });

    $('body').on('click', 'a.link_partner', function() {

        var mpush  = new Object;
        mpush.event = 'Arenter';
        mpush.eventCategory = 'Content';
        mpush.eventAction = $(this).text();
        if ($(this).hasClass('image')) {mpush.eventAction =  $(this).find('img').attr('alt');}
        if (mpush.eventAction == '') {mpush.eventAction =  $(this).attr('href');}
        mpush.eventAction = mpush.eventAction.trim();
        mpush.eventLabel =  $(this).attr('href');

        dataLayer.push(mpush);
        return false;
    });


    $('body').on('click', '.header_menu', function() {

        var mpush  = new Object;
        mpush.event = 'Arenter';
        mpush.eventCategory = 'Menu';
        mpush.eventAction = 'Меню';
        if ($(this).hasClass('search_button')) {mpush.eventAction = 'Поиск';}
        if ($(this).hasClass('hamburger_button')) {mpush.eventAction = 'Гамбургер-меню';}
        if ($(this).hasClass('cart_button')) {mpush.eventAction = 'Корзина';}
        if ($(this).hasClass('profile_button')) {mpush.eventAction = 'Профиль';}
        if ($(this).hasClass('order_button')) {mpush.eventAction = 'Мои заказы';}
        if ($(this).hasClass('logout_button')) {mpush.eventAction = 'Выход из ЛК';}

        mpush.eventLabel = document.location.href;

        dataLayer.push(mpush);
        return true;

    });

    $('body').on('click', 'a.link_service', function() {
        var mpush  = new Object;
        mpush.event = 'Arenter';
        mpush.eventCategory = 'Info';
        mpush.eventAction =  $(this).text();
        if ($(this).hasClass('but1')) {mpush.eventAction = 'Без залога';}
        if ($(this).hasClass('but2')) {mpush.eventAction = 'Качественные вещи';}
        if ($(this).hasClass('but3')) {mpush.eventAction = 'Удобная доставка';}
        mpush.eventLabel = document.location.href;
        mpush.eventAction = mpush.eventAction.trim();

        dataLayer.push(mpush);
        return true;
    });




    $('body').on('click', 'a.link_info', function() {
        var mpush  = new Object;
        mpush.event = 'Arenter';
        mpush.eventCategory = 'Info';
        mpush.eventAction = $(this).text();
        if (mpush.eventAction == '') {mpush.eventAction =  $(this).attr('href');}
        mpush.eventLabel = document.location.href;
        dataLayer.push(mpush);
    });


    $('body').on('click', '.footer_social_buttons a', function() {
        var mpush  = new Object;
        mpush.event = 'Arenter';
        mpush.eventCategory = 'Network';
        mpush.eventAction =  $(this).attr('title');
        mpush.eventLabel = document.location.href;

        dataLayer.push(mpush);
        return true;

    });
    $('body').on('click', 'a.footer_mail', function() {
        var mpush  = new Object;
        mpush.event = 'Arenter';
        mpush.eventCategory = 'Contact';
        mpush.eventAction = 'Почта';
        mpush.eventLabel = document.location.href;

        dataLayer.push(mpush);
    });

    $('body').on('click', 'a.link_phone', function() {
        var mpush  = new Object;
        mpush.event = 'Arenter';
        mpush.eventCategory = 'Call';
        mpush.eventAction = 'Footer';
        if ($(this).hasClass('header_phone')) {mpush.eventAction = 'Header';}
        mpush.eventLabel = document.location.href;
        dataLayer.push(mpush);
    });

    // Сразу кидалось в корзину
    //$('body').on('click', '.cart_list_form .optional_product_link', function() {optional_to_cart($(this).parents('.optional_product_wrapper'));return false;});

    $('body').on('submit', '.fastview_add_to_cart', function() {return fastview_to_cart($(this));});



    $('body').on('click', '.optional_product_link', function() {return send_ga_product_list_click();});
    send_ga_product_list();

    $('body').on('submit', '.header_search_form', function() {
        $('.header_search_form').attr('action', $('.header_search_form').attr('action')+'&q='+$('.header_search_form').find('.search_value').val());
        //console.log($('.header_search_form').attr('action'));

        return true;
    });
    $('body').on('click', '.js-order-table-review', function(e) {
        e.preventDefault();
        $(this).toggleClass('is-open').closest('.order-table__i-box').find('.order-table__review-dd').slideToggle();
    });


    $('body').on('click', '.photocomplect .product_nav_link', function() {
        var id = $(this).attr('href');
        id = id.replace('#', '');
        $('.photocomplect .product_full_info').addClass('nod');
        $('.photocomplect .product_full_info_'+id).removeClass('nod');
        $('.photocomplect .product_nav_link').removeClass('is-current');
        $(this).addClass('is-current');
        return false;
    });

    $('.photocomplect .product_full_info').removeClass('nod');


    if(width > 750){
        initNavSlider();
    }


    //catalog-menu current item scroll to visible area
    if(width <= 750 && $('body').find('.photocomplect__nav-list').length > 0){
        var currentItem = $('.photocomplect__nav-link.is-current');
        $('.photocomplect__nav-list').scrollLeft(currentItem.position().left - width/2 + currentItem.outerWidth()/2);
    }
    var num = 0;
    $('.photocomplect .product_full_info').each(function() {
        if (num > 0) {$(this).addClass('nod');}
        num++;
    });
    //catalog-menu current item scroll to visible area
    if(width <= 750 && $('body').find('.photocomplect__nav-list').length > 0){
        var currentItem = $('.photocomplect__nav-link.is-current');
        $('.photocomplect__nav-list').scrollLeft(currentItem.position().left - width/2 + currentItem.outerWidth()/2);
    }
    check_price_slider();
    check_common_search_form($('#common_search_form'), 0);

    $('.js-mob-sort-toggle').unbind('click');
    $('body').on('click', '.js-mob-sort-toggle', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if ($(this).next().find('.select-styled').hasClass('is-active'))
        {
            $(this).next().find('.select-styled').removeClass('active');
            $(this).next().find('.select-styled').removeClass('is-active');
        }
        else
        {
            $(this).next().find('.select-styled').addClass('active');
            $(this).next().find('.select-styled').addClass('is-active');
        }
        //$(this).next().find('.select-styled').trigger('click');
    });

    $('body').on('click', '.plus_arenda', function() {$(this).parents('.add_cart_form').find('.js-product-tariff-active').click();});
    check_log_ga();

}
//$(".js-input-tel-new").mask("+7(999) 999-99-99");

/* $(".js-input-tel-new").mask('+7(9ZZ) ZZZ-ZZ-ZZ', {
     placeholder: "+7(9__)___-__-__",
     translation: {
         'Z': {pattern: '/[0-9]/', optional: true},
         '9': {optional: false}
         }
     });
*/


Share = {
    whatsapp: function(purl, text) {
        url  = 'https://web.whatsapp.com/send?';
        url += '&text='    + encodeURIComponent(purl) + ' ' + encodeURIComponent(text);
        Share.popup(url);
    },
    telegram: function(purl, text) {
        url  = 'https://tttttt.me/share/url?';
        url += '&url='    + encodeURIComponent(purl);
        Share.popup(url);
    },
    skype: function(purl, text) {
        url  = 'https://web.skype.com/share?url=?';
        url += '&url='    + encodeURIComponent(purl);
        Share.popup(url);
    },
    vkontakte: function(purl, ptitle, pimg, text) {
        url  = 'http://vkontakte.ru/share.php?';
        url += 'url='          + encodeURIComponent(purl);
        url += '&title='       + encodeURIComponent(ptitle);
        url += '&description=' + encodeURIComponent(text);
        url += '&image='       + encodeURIComponent(pimg);
        url += '&noparse=true';
        Share.popup(url);
    },
    odnoklassniki: function(purl, text) {
        url  = 'https://connect.ok.ru/offer?';
        url += '&title=' + encodeURIComponent(text);
        url += '&url='    + encodeURIComponent(purl);
        Share.popup(url);
    },
    facebook: function(purl, ptitle, pimg, text) {
        url  = 'http://www.facebook.com/sharer.php?s=100';
        url += '&p[title]='     + encodeURIComponent(ptitle);
        url += '&p[summary]='   + encodeURIComponent(text);
        url += '&p[url]='       + encodeURIComponent(purl);
        url += '&p[images][0]=' + encodeURIComponent(pimg);
        Share.popup(url);
    },
    twitter: function(purl, ptitle) {
        url  = 'http://twitter.com/share?';
        url += 'text='      + encodeURIComponent(ptitle);
        url += '&url='      + encodeURIComponent(purl);
        url += '&counturl=' + encodeURIComponent(purl);
        Share.popup(url);
    },
    mailru: function(purl, ptitle, pimg, text) {
        url  = 'http://connect.mail.ru/share?';
        url += 'url='          + encodeURIComponent(purl);
        url += '&title='       + encodeURIComponent(ptitle);
        url += '&description=' + encodeURIComponent(text);
        url += '&imageurl='    + encodeURIComponent(pimg);
        Share.popup(url)
    },

    popup: function(url) {
        window.open(url,'','toolbar=0,status=0,width=626,height=436');
    }
};

$(window).on('scroll', function() {
    if($(this).scrollTop() > height/2) {
        $('body').addClass('is-product-fixed');
    }else{
        $('body').removeClass('is-product-fixed');
    }
});



$(window).on('resize', function() {
    set_search_events();
    check_calendar_position();
});

window.dadata_token = '';

function initNavSlider() {

}

function check_sub_type_button(elem)
{
    if (elem)
    {
        var sub_type = $(elem).parents('.add_cart_form').find('.item_sub_type').val();

        if (sub_type)
        {
            $('.product-fixed .sub_type_wrapper').addClass('nod');
            $('.product-fixed .'+sub_type+'_wrapper').removeClass('nod');

        }
    }
}

function check_log_ga()
{
    if(ga)
    {
        ga(function(tracker) {
            var clientId = tracker.get('clientId');
            var utm_log_id = parseInt($('.need_log_ga_sid').text());
            if (utm_log_id)
            {
                var data = new Object;
                data.utm_log_id = utm_log_id;
                data.ga_cid = clientId;
                var ajax_obj = {
                    url: '/set_ga/',
                    type: 'post',
                    data: data,
                    dataType:'text',
                    complete: function(data)
                    {
                        $('.need_log_ga_sid').remove();
                    },
                    cache: false,
                    async: true
                };
                $.ajax(ajax_obj);
            }
        });
    }
}

function check_price_slider()
{
    var slider = $('.js-price-slider');
    var parent = slider.closest('.filter-price');
    var min = parseInt(slider.data('min'), 10);
    var max = parseInt(slider.data('max'), 10);
    var from = parseInt(slider.data('from'), 10);
    var to = parseInt(slider.data('to'), 10);
    var inputMin = parent.find('.js-price-min')[0];
    var inputMax = parent.find('.js-price-max')[0];
    try
    {
        if (slider.length > 0)
        {
            if (slider[0].noUiSlider) {slider[0].noUiSlider.destroy();}

            noUiSlider.create(slider[0], {
                start: [from, to],
                range: {
                    'min': [min],
                    'max': [max]
                },
                connect: true,
                step: 1,
                format: {
                    to: function (value) {
                        return value.toLocaleString();
                    },
                    from: function (value) {
                        return value.toLocaleString();
                    }
                },
            });
            slider[0].noUiSlider.on('update', function (values, handle) {
                (handle ? inputMax : inputMin).value = values[handle];
            });
        }
    } catch(err) {console.log(err);}

    //filter input change
    $('.noUi-touch-area').unbind('mouseup');
    $('.noUi-touch-area').on('mouseup', function() {$('.price_from').change();});
    parent.find('.js-price-min').on('change', function() {
        var val = $(this).val().replace(/[^0-9]/gi, "");
        if(val < slider[0].noUiSlider.get()[1]) {
            slider[0].noUiSlider.set([parseInt($(this).val(), 10), null]);
        } else {
            $(this).val(slider[0].noUiSlider.get()[0]);

        }
    });
    parent.find('.js-price-max').on('change', function() {

        var val = $(this).val().replace(/[^0-9]/gi, "");
        if(val > slider[0].noUiSlider.get()[0]) {
            slider[0].noUiSlider.set([null, parseInt(val, 10)]);
        } else {
            $(this).val(slider[0].noUiSlider.get()[1]);

        }
    });
}

function show_product_image(e, elem)
{
    if (elem)
    {
        var count = $(elem).find('.product_list_image').length;

        if (count > 0)
        {
            var wid = $(elem).width() / count;
            var offset = $(elem).offset();
            var relativeX = (e.pageX - offset.left);
            $(elem).find('.product_list_image').addClass('nod');
            var num = parseInt(relativeX / wid);
            $(elem).find('.product_list_image_'+num).removeClass('nod');
        }
    }
}

function check_favorite(elem)
{


    var fav = getCookie('favorite');

    var list = new Array;
    if (fav != null) {list = fav.split(',');}
    if ($(elem).attr('href'))
    {
        $('.favorite_button').removeClass('_inlist');

        var id = $(elem).attr('href').replace("#","");
        console.log(id);
        id = parseInt(id);


        var new_list = [];
        var good = 0;
        var k = 0;
        for (i = 0; i < list.length;i++)
        {
            if (parseInt(list[i]) != id)
            {
                new_list[k] = parseInt(list[i]);
                $('.favorite_button_'+new_list[k]).addClass('_inlist');
                k++;
            }
            else
            {
                good = 1;
            }
        }
        if (good == 0)
        {
            new_list[k] = id;
            $('.favorite_button_'+id).addClass('_inlist');
        }
        if (good == 1)
        {
            $('.favorite_item_wrapper_'+id).remove();

        }
        list = new_list;
    }
    $('.favorite_count').html('').addClass('nod');
    delCookie('favorite');
    if (list.length > 0)
    {
        $('.favorite_count').html(list.length).removeClass('nod');
        fav = list.join(',');
        window.setCookie('favorite', fav);
    }
    $('.favorite_list_wrapper').each(function() {
        if ($(this).find('.favorite_item_wrapper').length == 0)
        {
            $('.favorite_list_wrapper').html('Избранные товары отсутствуют<br><br>').addClass('cent');
        }
    });

    return false;
}

function send_ga_product_list(selector)
{
    if (!selector) {var selector = '.optional_product_wrapper';}
    var num = 1;
    $(selector).each(function() {
        var obj = get_values($(this), '.cell_info');
        obj.list = 'Search Results';
        obj.position = num;
        try {ga('ec:addImpression', obj);} catch {}
        num++;
    });
    //if (num > 1) {ga('send', 'pageview');}
}

function send_ga_product_list_click(selector)
{
    if (!selector) {var selector = '.optional_product_wrapper';}
    var wrapper = $(this).parents(selector);
    var obj = get_values(wrapper, '.cell_info');
    ga('ec:addProduct', obj);
    ga('ec:setAction', 'click', {list: 'Search Results'});
    // Клик по продукту и перенаправление пользователя на страницу товара
    ga('send', 'event', 'UX', 'click', 'Results', {
        'hitCallback': function() {return true;}
    });
}


function review_save(elem)
{
    if (elem)
    {
        var message = $(elem).find('.review-text').val();
        //console.log(message.length);
        if (message.length <= 20) {$(elem).find('.error_wrapper').html('Ваш отзыв слишком короткий. Скорее всего, он не пройдет модерацию.').removeClass('nod');}
        if (message.length > 20)
        {
            window.setCookie('review_text', message);
            $(elem).find('.submit_button').addClass('nod');
            $(elem).find('.save_button').removeClass('nod');
            $(elem).find('.error_wrapper').html('').addClass('nod');
        }
    }
    return false;
}

function set_search_events()
{
    $('body').on('click', '.header__rmenu-search', function(e) {
        $('.searchform').fadeIn(250).find('.searchform__input').focus();
        if ($('.searchform').find('.searchform__input').val() != '') {fly_search($('.searchform').find('.searchform__input'));}
    });


    //if(width > 768)
    //{
        $('body').on('keyup input focus blur', '.searchform__input, .searchform-helper__input', function(e){
            flyDebounce(() => fly_search(this), 500);
        });

        //$('body').unbind('blur', '.searchform__input');

    /*}
    else
    {
        $('body').on('focus', '.searchform__input', function(e){fly_search($('.search_form_input_mob'));});
        $('body').on('keyup input', '.search_form_input_mob', function(e){

            flyDebounce(() => fly_search(this), 500);
        });
        $('body').on('click', '.js-search-toggle', function(e) {
            if($('body').hasClass('is-search-help-open'))
            {
                $('body').removeClass('is-search-help-open');
                $('.searchform__helper-mob').hide(0);
            }

        });

    }*/


    /*$('body').on('blur', '.searchform__input', function(e){
        setTimeout(function() {
            $('.searchform__helper').fadeOut(100);
            $('.searchform').fadeOut(250).find('.searchform__input');
            $('body').removeClass('is-search-help-open');
        }, 500);

    });*/
    $('body').on('click', '.js-search-toggle', function(e) {
        $('.header_search_form').fadeIn(250).find('.header_search_form_input').focus();
    });



}
var first_search = 0;
window.last_search_str = '';
var fly_search_time = new Date();
var fly_active = 0;

function fly_search(elem) {
    if (!elem) {
        return false;
    }
    var time = new Date;
    fly_search_time = new Date;

    fly_active = 0;
    var form = $(elem).parents('form');
    var data = get_values(form, '.add_field');

    if (data.search_str.length < 2) {
        window.last_search_str = '';
        $('.searchform-helper__result').remove();
        return false;
    }
    /*if ($(form).hasClass('fly_search_mobile')) {
        data.search_from = 'mobile';
    }*/
    if (data.search_str != window.last_search_str || first_search == 0) {
        first_search = 1;
        var ajax_obj = {
            url: '/catalog/fly_search/',
            type: 'post',
            beforeSend: function () {
                window.yaParams = { "Fly_search": data.search_str };
                const noop = () => {};
                const ymWrapper = ym || noop;
                ymWrapper(51068642, 'params', window.yaParams || {});
            },
            data,
            dataType: 'json',
            complete: function (resp) {
                $('.searchform-helper__result').remove();
                /*if (width > 750) {
                    $('body').removeClass('is-search-helper-open');
                }*/

                if (resp.responseText) {

                    let res;
                    window.last_search_str = data.search_str;
                    try {
                        res = $.parseJSON(resp.responseText);
                    } catch (err) {
                        res = {};
                    }

                    if (res.html) {
                        $('.searchform-helper').append(res.html);
                        if (width > 750) {
                            $('body').addClass('is-search-helper-open');
                            //$('.pickpoint-select__scroller').jScrollPane({ mouseWheelSpeed: 20 });
                        }
                    }
                }
            },
            cache: false,
            async: true
        };

        $.ajax(ajax_obj);
    }
}

function check_header_infoblock(elem)
{
    if (elem)
    {
        var order_id = $(elem).parents('.header-infoblock').find('.order_id').val();
        var str = getCookie('infoblock_list');
        var list = new Array;
        if (str) {list = str.split(',');}
        var is = 0;
        for(i = 0; i<list.length;i++)
        {
            list[i] = parseInt(list[i]);
            if (list[i] == order_id) {is = 1;}
        }
        if (is == 0) {list[list.length] = order_id;}

        if (list.length > 0) {window.setCookie('infoblock_list', list.join(','), 1);}

        $('.header-infoblock').parents('.page').removeClass('with_infoblock');
        $('.header-infoblock').remove();
    }

}


function show_category_child(elem)
{

    var data = new Object();
    data.menu_id = $(elem).data('menu');
    var name = $(elem).find('.catalog-popup__menu-name').text();
    if ($(elem).hasClass('catalog-popup__submenu-link')) {name = $(elem).text();}

    var ajax_obj = {
        url: '/show_category_child/',
        type: 'post',
        beforeSend: function() {},
        data: data,
        dataType:'json',
        complete: function(data) {
            if (data.responseText)
            {
                try {res = $.parseJSON(data.responseText);} catch(err) {res = new Object();}
                if (res.html)
                {
                    $('.catalog-popup__content').append(res.html);
                    setTimeout(function(){
                        $('.catalog-popup__submenu').eq(-1).addClass('is-open');
                        $('.catalog-popup').addClass('is-submenu-open');
                        $('.catalog-popup__title').text(name);
                    },10);
                }
            }
        },
        cache: false,
        async: true
    };

    $.ajax(ajax_obj);
}

function unknown_error(log)
{
    if (log)
    {
        //console.log(log);
    }
    res = new Object();
    res.result = 0;
    res.message = 'It\'s impossible...';
    return res;
}


function check_phone_mask(elem)
{

    //$(".js-input-tel").mask("+7(999) 999-99-99");
    if (elem)
    {
        var input = elem;
        setTimeout(function() {
            input.setSelectionRange(0, 2);
        }, 0);
    }
}

function ya_reach_goal(goal)
{
    // отправка событий на давно отключенную метрику?
    if (goal) {
        try {
            //yaCounter51068642.reachGoal(goal);
            //console.log(goal);

        } catch (err) {}
    }
    return true;
}

function check_popup(e)
{
    //e.preventDefault();
    var id = $(this).attr('href');
    if (!id) {
        return false;
    }

    if ($(this).hasClass('link_phone')) {
        id = '#popup-callback';
    }
    var intitiator = this;
    if ($(this).hasClass('reload_popup')) {
        $(id).remove();
    }
    if ($(id).length > 0) {
        show_popup($(id));
        return;
    }
    let popupData = {};
    popupData.id = id.replace('#', '');
    $(this).find('.add_field').each(function () {
        popupData[$(this).attr('name')] = $(this).val();
    });

    if ($(this).find('.fields_wrapper').val()) {
        var fields = '.add_class';
        if ($(this).find('.fields_class').val()) {
            fields = $(this).find('.fields_class').val();
        }
        popupData = get_values($($(this).find('.fields_wrapper').val()), fields, popupData);
    }

    var ajax_obj = {
        url: '/show_popup/',
        type: 'post',
        data: popupData,
        dataType: 'json',
        complete: function (response) {
            if (!response.responseText) {
                return;
            }
            let res;
            try {
                res = eval('(' + response.responseText + ')');
            } catch (e) {
                res = {};
            }
            if (!res.html) {
                return;
            }
            if (!$(id).length) {
                let ready = 0;
                if ($(intitiator).hasClass('put_next')) {
                    ready = 1;
                    $(intitiator).after(res.html);
                }
                if (ready === 0) {
                    ready = 1;
                    $('body').append(res.html);
                }
                window.addMasks(document);
                //$(".js-input-tel").mask("+7(999) 999-99-99");
                show_popup($(id));
            }
            $('.popup').find('.selectstyle').each(function (i) {
                window.update_select_style(this);
                // выше уже повесили слушатель на body, так что все добавленные элементы попадут тоже
                // $('.cart_param_list').on('click', function() {return set_cart_param(this);});
            });
        },
        cache: false,
        async: false
    };

    $.ajax(ajax_obj);
    return false;
}

function show_popup(elem)
{
    if (elem)
    {
        var id = $(elem).attr('id');
        if (id)
        {
            var btn = $('a[href="#'+id+'"');
            if ($(btn).hasClass('prolong_button'))
            {
                var offset = btn.offset();
                btn.toggleClass('is-open')


                if(Math.max($(window).width(), window.innerWidth) > 450){
                    var top = offset.top + btn.outerHeight() + 2;
                    var left = offset.left - 375 + btn.outerWidth();
                }else{
                    var top = offset.top + btn.outerHeight() + 2;
                    var left = 12;
                }
                $(elem).css({top:top,left:left});
                $(elem).fadeToggle(200);

            }
            else
            {
                $(elem).fadeIn(400);
                $('body').addClass('is-popup-open');
                if ($(elem).find('.product-subs__offer').length > 0)
                {
                    equalheight('.product-subs__offer-info');
                    equalheight('.product-subs__offer-term');
                }
            }
        }
    }
}

var need_show_cart_popup = 0;
function remove_from_cart(elem)
{
    if (!elem) {
        return false;
    }
    $('.js-popup-cart').mouseout();
    if ($(elem).parents('.cart-popup').length > 0) {
        need_show_cart_popup = 1;
    }
    $(elem).addClass('nod');
    $(elem).parents('.cart_item_list_wrapper').addClass('nod');
    var item_id = $(elem).parents('.cart_item_list_wrapper').find('.item_id').val();
    var removed = 0;

    $('.cart_list_form .cart_item_list_wrapper').each(function () {
        if ($(this).find('.item_id').val() == item_id) {
            elem = $(this).find('.item_id');
        }
    });
    $(elem).parents('.cart_item_list_wrapper').find('.amount_field').val(0);
    send_ecommerce_remove(elem);
    get_compact_list();

    try {
        window.update_cart_item(elem);
    } catch (e) {
        console.log(e);
    }
}

function send_ecommerce_remove(elem)
{
    if (elem)
    {
        var wrapper = $(elem).parents('.cart_item_list');
        if (wrapper)
        {
            try {
                remove_obj = new Object;
                remove_obj.ecommerce = new Object;
                remove_obj.ecommerce.currencyCode = "RUB";
                remove_obj.ecommerce.remove = new Object;

                remove_obj.ecommerce.remove.products = get_ecom_cart_product(wrapper);
                ya_dataLayer.push(remove_obj);
                //console.log('удаление');
                //console.log(remove_obj);
            } catch (err) {}

            try {
                var obj = get_ecom_cart_product(wrapper);
                ga("ec:addProduct", obj);
                ga("ec:setAction", "remove");
                ga("send", "event", "detail view", "click", "removeFromCart");
            }  catch (err) {}


        }

    }
    return true;
}

function get_ecom_cart_product(wrapper)
{
    if (wrapper)
    {
        product = new Object;
        product.id = $(wrapper).find('.product_id').val();
        product.name = $(wrapper).find('.order-list__i-name').html();

        var type = $(wrapper).find('.item_type').val();
        if (type == 'sub')
        {
            var category_list = $(wrapper).find('.order-list__i-content .order-list__i-type');
            if (category_list.length > 0)
            {
                product.category =  $(category_list[0]).html();
                if (category_list.length > 1)
                {
                    product.name = $(category_list[1]).html();
                    product.variant = $(wrapper).find('.order-list__i-name').html();
                } else {product.name = $(wrapper).find('.order-list__i-name').html();}
            }
            product.category = product.category.replace(/[^a-zA-ZА-Яа-я\s]/g, '').trim();
        }
        if (type == 'arenda' || type == 'buy')
        {
            if ($(wrapper).find('.product_full_category')) {product.category =  $(wrapper).find('.product_full_category').val();}
            if ($(wrapper).find('.product_brand')) {product.brand =  $(wrapper).find('.product_brand').val();}
        }

        if ($(wrapper).find('.sum_field')) {product.price = $(wrapper).find('.sum_field').val();}
        if ($(wrapper).find('.amount_field')) {product.quantity = $(wrapper).find('.amount_field').val();}
        return product;
    }
}


function pageX(elem) {
    if (elem) {return elem.offsetParent ? elem.offsetLeft + pageX( elem.offsetParent ) :  elem.offsetLeft;}
}

function pageY(elem) {
    if (elem) {return elem.offsetParent ? elem.offsetLeft + pageY( elem.offsetParent ) :  elem.offsetLeft;}
}

// Определение координаты элемента по вертикали

function get_top(elem) {
    if (elem) {return elem.offsetParent ? elem.offsetTop + get_top( elem.offsetParent ) : elem.offsetTop;}
}

function change_sub_product(elem)
{
    if (elem)
    {
        var wrapper = $(elem).parents('.button_wrapper');
        var item_wrapper = $(elem).parents('.product-in-tarif')
        var form = $(elem).parents('.add_cart_form');
        var input = $(wrapper).find('.product_in_sub');
        var primary_product = $(wrapper).find('.primary_product_id');
        var product_id = $(wrapper).find('.product_id').val();
        var list_container = $(item_wrapper).parents('.product-tarif__products-list');

        if (primary_product.length > 0)
        {
            var good_primary = check_primary_product_in_sub(primary_product, form);

            if (good_primary == 0)
            {
                $(primary_product).each(function() {
                    var primary_id = $(this).val();
                    if (primary_id)
                    {

                        var primary_list = $(form).find('.product-in-tarif.product_'+primary_id);
                        $(primary_list).each(function() {
                            if (good_primary == 0)
                            {
                                $(this).addClass('in-list');
                                $(this).find('.product_in_sub').val(1);
                                good_primary = 1;
                                $(this).find('.no-current').addClass('add');
                                $(this).find('.is-current').removeClass('del').addClass('in-list');
                            }
                        });

                    }
                });
            }
        }

        var max = $(form).find('.max_item_count').val();
        var vis = $(form).find('.visible_in_sub');
        $(vis).removeClass('red');

        var count1 = $(form).find('.change_sub_product.add:not(.is_primary_product)').length;
        var count2= $(form).find('.change_sub_product.in-list:not(.is_primary_product)').length;
        var count = count1 + count2;

        if ($(input).val() == 0 && count < max)
        {
            $(input).val(1);
            $(item_wrapper).addClass('in-list');
            if ($(elem).hasClass('no-current')) {$(elem).addClass('add');}
            if ($(elem).hasClass('is-current')) {$(elem).removeClass('del').addClass('in-list');}
        }
        else
        {
            $(input).val(0);
            $(item_wrapper).removeClass('in-list');
            if ($(elem).hasClass('no-current')) {$(elem).removeClass('add');}
            if ($(elem).hasClass('is-current')) {$(elem).removeClass('in-list').addClass('del');}
        }

        if ($(wrapper).hasClass('is_primary_product'))
        {
            var list = $(wrapper).find('.product_id');
            var good_primary = check_primary_product_in_sub(list, form);
            if (good_primary == 0)
            {
                $(list).each(function() {
                    var product_list = $(form).find('.product-in-tarif:not(.is_primary_product)');
                    $(product_list).each(function() {
                        primary_list = $(this).find('.primary_product_id');
                        var product_has_primary = check_primary_product_in_sub(primary_list, form);
                        if (product_has_primary == 0)
                        {
                            $(this).removeClass('in-list');
                            $(this).find('.product_in_sub').val(0);
                            $(this).find('.no-current').removeClass('add');
                            $(this).find('.is-current').removeClass('in-list').addClass('del');
                        }
                    });
                });
            }
        }
        var count1 = $(form).find('.change_sub_product.add:not(.is_primary_product)').length;
        var count2= $(form).find('.change_sub_product.in-list:not(.is_primary_product)').length;
        var count = count1 + count2;
        var avail = max - count;

        var sub_text = '(выбрано: '+count+' шт, осталось выбрать: '+avail+' шт.)';
        $(vis).html(sub_text);
        var sub_text = 'выбрано: '+count+' шт<br/>осталось выбрать: '+avail+' шт.';
        if (avail == 0) {sub_text = 'Вы выбрали максимальное число вещей внутри тарифа. Удалите вещи или перейдите на другой тариф'}
        $('#sub-product .sub-popup-text').html(sub_text);
        if (avail == 0)
        {
            show_popup($('#sub-product'));
            setTimeout(function() {$('#sub-product .js-popup-close').click();}, 3000);
        }

        check_order_sub_products();
    }
}

function check_order_sub_products()
{
    var arr = new Array();
    $('.product-i.product-in-tarif.in-list').each(function() {
        arr.unshift($(this));
    })

    $(arr).each(function() {
        $(this).prependTo($(this).parents('.product-tarif__products-list'));
    });
}

function check_primary_product_in_sub(list, wrapper)
{
    var good_primary = 0;
    if (wrapper && list)
    {

        $(list).each(function() {
            var primary_id = $(this).val();
            if (primary_id)
            {
                var primary_list = $(wrapper).find('.product-in-tarif.product_'+primary_id);
                $(primary_list).each(function() {
                    if ($(this).find('.product_in_sub').val() > 0) {good_primary = 1;}
                });
            }
        });
    }
    return good_primary;
}

function product_in_complect(elem)
{
    if (elem)
    {
        var wrapper = $(elem).parents('.complect_product_list_wrapper');
        var input = $(wrapper).find('.in_complect');
        if ($(input).val() == 1)
        {
            $(input).val(0);
            $(elem).find('.del').addClass('nod');
            $(elem).find('.add').removeClass('nod');
        }
        else
        {
            $(input).val(1);
            $(elem).find('.del').removeClass('nod');
            $(elem).find('.add').addClass('nod');
        }
    }
}

function set_counter(elem)
{
    if (elem)
    {
        var wrapper = $(elem).parents('.phone_block_wrapper');
        var new_number = parseInt($(elem).html()) - 1;
        if (new_number < 0)
        {
            $(elem).parent().html('');
            $(wrapper).find('.activation_phone_button').removeClass('is_disabled').removeClass('nod');
            $(wrapper).find('.login_phone_button').removeClass('is_disabled').removeClass('nod');
            $(wrapper).find('.is-process').addClass('nod');
        }
        else
        {
            $(elem).html(new_number);
            setTimeout(function() {set_counter(elem);}, 1000);
            $(wrapper).find('.activation_phone_button').addClass('is_disabled').addClass('nod');
            $(wrapper).find('.login_phone_button').addClass('is_disabled').addClass('nod');
            $(wrapper).find('.is-process').removeClass('nod');
        }
    }
}


function check_card(elem)
{
    if (elem)
    {
        var wrapper = $(elem).parents('.check_card_wrapper');
        var is_ok = check_field($(wrapper).find('.check_card_field'), 1);

        if (is_ok)
        {
            var data = new Object;
            data.amount = $(wrapper).find('.check_card_field').val();
            data.card_id = $(wrapper).find('.check_card_id').val();
            data.shop_id = $(wrapper).find('.check_shop_id').val();
            //console.log(data);
            var ajax_obj = {
                url: '/profile/cards/check/',
                type: 'post',
                beforeSend: function() {$(wrapper).find('.alert').addClass('nod');$(wrapper).find('.is-begin').addClass('nod');$(wrapper).find('.is-wait').removeClass('nod');},
                data: data,
                dataType:'json',
                complete: function(data)
                {
                    if (data.responseText)
                    {

                        try {res=eval( '('+data.responseText+')' );}
                        catch (e)
                        {
                            res = new Object;
                            res.result = 0;
                        }
                        $(wrapper).find('.is-wait').addClass('nod');
                        if (res.result == 1)
                        {
                            if (res.message) {$(wrapper).find('.alert-success').html(res.message).removeClass('nod');}
                            setTimeout(function () {window.location.reload();}, 3000);
                        }

                        if (res.result == 0)
                        {
                            $(wrapper).find('.is-begin').removeClass('nod');
                            if (res.error) {$(wrapper).find('.alert-error').html(res.error).removeClass('nod');}
                        }
                    }
                },
                cache: false,
                async: true
            };

            $.ajax(ajax_obj);
        }
    }
}

function check_phone_activation_code(elem) {
    if (!elem) {
        return;
    }

    var contact_wrapper = $(elem).parents('.contact_html');
    var wrapper = $(elem).parents('.inputbox');
    var form = $(elem).parents('form');
    var is_ok = check_field($(wrapper).find('.check_phone_field'), 1);

    if (!is_ok) {
        return;
    }

    const data = {};
    var input = $(wrapper).find('.check_phone_field')
    data.code = $(input).val();
    data.phone = $(wrapper).find('.phone_field').val();
    if ($(form).find('.mail_field').length) {
        data.mail = $(form).find('.mail_field').val();
    }

    if ($(input).hasClass('need_auth')) {
        data.need_auth = 1;
    }
    var ajax_obj = {
        url: '/profile/activation/phone/check/',
        type: 'post',
        beforeSend: function () {
            $(elem).addClass('nod');
            $(wrapper).find('.is-wait').removeClass('nod');
            $(wrapper).find('.is-process').addClass('nod');
        },
        data,
        dataType: 'json',
        complete: function (response) {
            if (!response.responseText) {
                return;
            }
            const res = eval('(' + response.responseText + ')');
            $(wrapper).find('.is-wait').addClass('nod');
            if (res.result == 1) {
                $(wrapper).find('.phone_counter').html(0);
                $(wrapper).find('.phone_counter').parent().addClass('nod');
                $(wrapper).find('.is-begin').addClass('nod');
                $(wrapper).find('.is-process').addClass('nod');
                if (res.message) {
                    $(wrapper).find('.alert-success').html(res.message);
                }
                if (res.thirdname) {
                    $(contact_wrapper).find('.patronymic').val(res.thirdname);
                }
                if (res.firstname) {
                    $(contact_wrapper).find('.name').val(res.firstname);
                }
                if (res.surname) {
                    $(contact_wrapper).find('.surname').val(res.surname);
                }
                if (res.user_token) {
                    $('.user_token').val(res.user_token);
                    var redirect = $(form).attr('action')
                    const tokenList = {
                        user_token: $('.user_token').val(),
                        h: $('.cart_token').val(),
                    };
                    const query = Object.entries(tokenList)
                        .filter(([, value]) => value)
                        .map(([key, value]) => key ? `${key}=${value}` : value);
                    if (query.length > 0) {
                        redirect += `?${query.join('&')}`;
                    }
                    window.location.href = redirect;
                }

                //if (res.mail) {$(contact_wrapper).find('.mail_field').val(res.mail);}
                //if ($(input).hasClass('need_auth')) {window.location.reload();}
                //if ($(input).hasClass('need_auth')) {$('#cart_list_form').submit();}

                //save_cart_user_info();
            } else if (res.result == 0) {
                $(wrapper).find('.is-process').removeClass('nod');
                if (res.error) {
                    $(wrapper).find('.alert-error').html(res.error).removeClass('nod');
                }
                /*if ($(input).hasClass('need_auth')) {
                    window.location.reload();
                }*/
            }

        },
        cache: false,
        async: true
    };

    $.ajax(ajax_obj);
}

function send_phone_activation_code(elem)
{
    if (elem)
    {
        var contact_wrapper = $(elem).parents('.contact_html');
        var wrapper = $(elem).parents('.inputbox');
        var data = {};


        data.phone = $(wrapper).find('.phone_field').val();
        if ($(elem).hasClass('in_profile'))
        {
            data.initiator = 'profile_phone_activation';
        }

        if ($(elem).hasClass('in_cart'))
        {
            data.initiator = 'cart_phone_activation';
        }

        if ($(elem).hasClass('need_auth'))
        {
            if ($(elem).hasClass('in_cart'))
            {
                data.initiator = 'cart_phone_authorization';
            }

            data.need_auth = 1;
            data.mail = $(contact_wrapper).find('.mail_field').val();
        }

        var ajax_obj = {
            url: `/profile/activation/phone/code/`,
            type: 'post',
            beforeSend: function () {
                $(elem).addClass('nod');
                $(wrapper).find('.is-wait').removeClass('nod');
                $(wrapper).find('.inputbox__error').html('');
                $(contact_wrapper).find('.phone_comment').html('');
                $(wrapper).find('.inputbox__input').removeClass('is-error');
            },
            data: data,
            dataType: 'json',
            complete: function (data) {
                if (data.responseText) {
                    let res;
                    try {
                        res = eval('(' + data.responseText + ')');
                    } catch (e) {
                        res = { result: 0 };
                    }
                    if (res.result == 1) {
                        $(wrapper).find('.is-wait').addClass('nod');
                        $(wrapper).find('.is-begin').addClass('nod');
                        $(wrapper).find('.is-process').removeClass('nod');
                        if (res.message) {
                            $(wrapper).find('.alert-success').html(res.message);
                        }
                        if (res.error) {
                            $(wrapper).find('.alert-error').html(res.error);
                        }
                    }

                    if (res.result == 0) {
                        $(wrapper).find('.is-wait').addClass('nod');
                        $(wrapper).find('.is-process').addClass('nod');
                        $(wrapper).find('.is-begin').removeClass('nod');
                        if (res.error) {
                            $(wrapper).find('.alert-error').html(res.error);
                        }
                    }
                    if (res.is_counter) {
                        $('.activation_phone_button').addClass('nod');
                        var counter = $('.phone_counter');
                        if (parseInt($(counter).html()) > 0) {
                            set_counter(counter);
                        }
                    }
                }
            },
            cache: false,
            async: true
        };

        $.ajax(ajax_obj);
    }
}


function send_mail_activation_mail(elem)
{
    if (elem)
    {
        var wrapper = $(elem).parents('.inputbox');
        var data = new Object;
        var contact_wrapper = $(elem).parents('.contact_html');
        var wrapper = $(elem).parents('.inputbox');
        var data = new Object;
        data.email = $(wrapper).find('.mail_field').val();
        var ajax_obj = {
            url: '/profile/activation/mail/',
            type: 'post',
            beforeSend: function() {$(elem).addClass('nod');$(wrapper).find('.is-wait').removeClass('nod');},
            data: data,
            dataType:'json',
            complete: function(data)
            {
                if (data.responseText)
                {
                    res=eval( '('+data.responseText+')' );
                    if (res.result == 1)
                    {
                        $(wrapper).find('.is-wait').addClass('nod');
                        $(wrapper).find('.is-begin').addClass('nod');
                        $(wrapper).find('.is-process').addClass('nod');
                        if (res.message) {$(wrapper).find('.alert-success').html(res.message);}
                    }

                    if (res.result == 0)
                    {
                        $(wrapper).find('.is-wait').addClass('nod');
                        $(wrapper).find('.is-process').addClass('nod');
                        $(wrapper).find('.is-begin').removeClass('nod');
                    }
                }
            },
            cache: false,
            async: true
        };

        $.ajax(ajax_obj);
    }
}



function set_cart_param(elem)
{
    if(elem)
    {
        var param = $(elem).find('.cart_param_list_id').val();
        $(elem).parents('.cart_param_main').find('.cart_param_id').val(param).trigger('change');
    }
}


function set_cart_address(elem)
{
    if (elem)
    {
        var addr = $(elem).find('input[name="address_id"]:checked');
        if (addr)
        {
            var addr_id	= $(addr).val();
            var address_street = $(addr).parent().find('.address_street').val();
            var address_house = $(addr).parent().find('.address_house').val();
            var address_flat = $(addr).parent().find('.address_flat').val();
            var address_is_default = $(addr).parent().find('.address_is_default').val();
            var address_entrance_floor_etc = $(addr).parent().find('.address_entrance_floor_etc').val();

            var target = $('#cart_address_wrapper');
            $(target).find('.address_street').val(address_street);
            $(target).find('.address_house').val(address_house);
            $(target).find('.address_flat').val(address_flat);
            $(target).find('.address_entrance_floor_etc').val(address_entrance_floor_etc);
            $(target).find('.address_id').val(addr_id);
            $(target).find('.address_is_default').val(address_is_default);
            $(elem).find('.popup__close').click();
        }
    }
    return false;
}

window.update_cart_form = function (elem) {

    $('.complect_init').val(1);
    var container = $('.add_cart_form');
    if (elem) {
        container = $(elem).parents('.add_cart_form');
    }

    if (container) {

        var add_container = $('.item_plashka');
        var data = new Object;
        data.amount = $(container).find('.amount_field').val();
        data.item_id = $(container).find('.item_id').val();
        data.item_type = $(container).find('.item_type').val();
        data.item_sub_type = $(container).find('.item_sub_type').val();
        data.date_from = $(container).find('.date_start').val();
        data.date_to = $(container).find('.date_end').val();
        var error = 0;

        var fix_container = $('.product-fixed .' + data.item_sub_type + '_wrapper');

        if (data.amount) {
            $(fix_container).find('.period').val(data.amount);
        }

        if (!data.amount) {
            data.amount = 1
        }
        if (!data.item_id) {
            error = 1;
        }
        if (!data.item_type) {
            error = 1;
        }

        if (error == 0) {
            if (data.item_type == "buy") {
                var new_buy_price = number_format(data.amount * $('.buy_price_single').val(), 0, ',', ' ')
                $('.buy_price').html(new_buy_price);
            }
        }

        if (data.item_sub_type != "sub" && data.item_sub_type != "sub_fix" && data.item_sub_type != "sub_fix_week" && data.item_type != "buy") {
            if (data.date_from == "01.01.2021" || data.date_from == "02.01.2021" || data.date_to == "01.01.2021" || data.date_to == "02.01.2021") {
                error = 1;
                $(container).find('.date-range').addClass('is-error');
                $('.order_button').attr('disabled', true);
            }

            if (error == 0 && (!data.date_from || data.date_from == data.date_to)) {
                var tmp = moment($(container).find('.date_start').val(), 'DD.MM.YYYY', true).add('days', 1);
                $(container).find('.date_end').val(tmp.format('DD.MM.YYYY')).trigger('change');
                var full = moment($(container).find('.date_start').val(), 'DD.MM.YYYY', true).format('DD MMM') + '<i class="datepicker__icon-sep"></i>' + tmp.format('DD MMM');
                $(container).find('.datepicker__data').html(full);
                data.date_to = $(container).find('.date_end').val();
            }
        }


        if (error == 0) {
            if (data.item_type == "complect") {
                var products = [];
                var counts = [];
                var p = 0;

                $(container).find('.complect_product_list_wrapper').each(function () {
                    var product = $(this).find('.count_in_complect');
                    var name = $(product).attr('name');
                    var tmp = name.split('[');
                    var tmp = tmp[1].split(']');
                    if ($(product).val() > 0) {
                        products[p] = tmp[0];
                        counts[p] = $(product).val();
                        p++;
                    }
                });
                data.products = products;
                data.counts = counts;
            }

            var ajax_obj = {
                url: '/cart/precart/',
                type: 'post',
                beforeSend: function () {
                    $('.day_count').html('<img class="loader" src="/assets/images/loader.gif">');
                },
                data: data,
                dataType: 'json',
                complete: function (data) {

                    if (data.responseText) {
                        try {
                            res = eval('(' + data.responseText + ')');
                        } catch (e) {
                            var res = new Object;
                        }

                        $('.day_count').html('');

                        if (res.price_grid_html) {
                            $(container).find('.price_grid_wrapper').html(res.price_grid_html);
                        }
                        if (res.product_count) {
                            $(container).find('.complect_product_count').html(res.product_count);
                        }
                        if (res.last_price) {
                            $(container).find('.day_price').html(res.last_price + ' <span class="rub">c</span>').parent().removeClass('nod');
                            if (res.discount) {
                                var discount = '';
                                if (res.discount > 0) {
                                    discount = '<mark>-' + res.discount + '</mark>%';
                                }
                                $(container).find('.day_price.complect').html($('.day_price.complect').html() + '<span class="product-complect__sale">' + discount + '</span>');

                            }
                        }
                        if (res.average_format) {
                            $(container).find('.day_price').parent().each(function () {
                                $(this).find('.from').addClass('nod');
                            });

                            $(container).find('.price-card__pricebox').find('strong').html(`${res.sum_format} <span>₽</span>`);
                            $(container).find('.price-card__term').html(`за ${res.days_format}`)
                            $(container).find('.day_price').html(res.average_format + ' <span class="rub">c </span>');
                            $(add_container).find('.day_price').html(res.average_format);
                            $(fix_container).find('.day_price').html(res.average_format + ' <span class="rub">c </span>');
                            if ($(container).find('.day_price').hasClass('no_r')) {
                                $(container).find('.day_price').html(res.average_format);
                            }
                            if (getCookie('need_priceswitch')) {
                                $(container).find('.day_price').html('<strong>' + res.average_format + '</strong> <span class="rub">c </span>' + time_period);
                            }
                            if (res.discount) {
                                var discount = '';
                                if (res.discount > 0) {
                                    discount = '<mark>-' + res.discount + '</mark>%';
                                }
                                $(container).find('.day_price.complect').html($('.day_price.complect').html() + '<span class="product-complect__sale">' + discount + '</span>');

                            }
                            if (res.days_format) {
                                $(container).find('.days_format').html(res.days_format);
                            }

                            $(container).find('.discount_wrapper').removeClass('nod').find('.discount').html('-' + res.drop_percent_format);

                        }
                        if (res.sum) {
                            $(container).find('.product-complect__pricebox').addClass('res');
                            $(container).find('.full_price').html('<strong><span class="price">' + res.sum_format + ' ₽</span> ').removeClass('nod');
                            var fix_html = '<strong>' + res.sum_format + ' <span class="rub">c </span></strong>';
                            fix_add = '';
                            if (res.days_format) {
                                fix_add = ' / ' + res.days_format;
                            }
                            if (res.period_format) {
                                fix_add = ' / ' + res.period_format;
                            }
                            fix_html += fix_add;
                            $(fix_container).find('.full_price').html(fix_html).parent().removeClass('nod');
                            if ($(container).find('.full_price').hasClass('is_instrument')) {
                                var day_text = res.sum_format + ' <span class="rub-hidden">руб.</span><span class="rub">c</span>';
                                day_text = '';
                                if (res.days_format) {
                                    day_text += ' / ' + res.days_format + '';
                                }
                                $(container).find('.full_price').html($(container).find('.full_price').html() + day_text);
                            }
                            $(container).find('.full_price').removeClass('nod');
                            if ($(container).find('.item_type').val() == 'complect' || $(container).find('.item_type').val() == 'complect_primary') {
                                $(container).find('.full_price').addClass('nodecor');
                            }
                            $('.more7000').addClass('nod');
                            $('.more5000').addClass('nod');
                            $('.more0').removeClass('nod');
                            try {
                                var sum = parseInt(res.sum.replace(' ', ''));
                            } catch (err) {
                            }

                            if (sum >= 3500 && sum < 5500) {
                                $('.more0').addClass('nod');
                                $('.more5000').removeClass('nod');
                            }
                            if (sum >= 5500) {
                                $('.more0').addClass('nod');
                                $('.more5000').addClass('nod');
                                $('.more7000').removeClass('nod');
                            }
                        }

                        if (res.product_all_price) {
                            for (key in res.product_all_price) {
                                if (res.product_all_price[key]) {
                                    $(container).find('.complect_product_all_price_' + key).html(res.product_all_price[key]).parent().removeClass('nod');
                                }
                            }
                        }

                        $(container).find('.complect_buy_sum_wrapper').addClass('nod');
                        $(container).find('.complect_buy_sum').html('')
                        if (res.buy_sum_format_html) {
                            $(container).find('.complect_buy_sum_wrapper').removeClass('nod');
                            $(container).find('.complect_buy_sum').html(res.buy_sum_format_html);
                        }

                        if (res.product_all_label) {
                            for (key in res.product_all_label) {
                                if (res.product_all_label[key]) {
                                    $(container).find('.complect_product_all_label_' + key).html(res.product_all_label[key]);
                                }
                            }
                        }

                        if (res.product_day_price) {
                            for (key in res.product_day_price) {
                                $(container).find('.complect_product_day_price_' + key).html(res.product_day_price[key]);
                            }
                        }

                        if (res.delivery_price_name) {
                            $(container).find('.delivery_price').html('Доставим по Москве <strong>БЕСПЛАТНО</strong>');
                            if (res.delivery_price) {
                                $(container).find('.delivery_price').html(res.delivery_price_name + ' (+' + res.delivery_price + '<span class="rub">a</span>)');
                            }
                        }

                        var period = '';
                        if (res.days_format) {
                            period = 'за ' + res.days_format;
                            period = '' + res.days_format;
                            if (!getCookie('need_priceswitch')) {
                                period = ' / ' + period;
                            }
                            if (res.discount) {
                                var discount = '';
                                if (res.discount > 0) {
                                    discount = '<mark>-' + res.discount + '</mark>%';
                                }
                                res.days_format += '<span class="discount product-simple__datebox-discount-num">' + discount + '</span>';
                            }
                            $(container).find('.day_count').html(res.days_format);
                        }
                        if (res.period_format) {
                            period = 'за ' + res.period_format;
                            period = res.period_format;
                            if (!getCookie('need_priceswitch')) {
                                period = ' / ' + period;
                            }
                        }
                        if (!$(container).find('.full_price').hasClass('is_instrument')) {
                            if (getCookie('need_priceswitch')) {
                                $(container).find('.full_price').html($(container).find('.full_price').html());
                                $('.period_format').html(period);
                            }
                            if (!getCookie('need_priceswitch')) {
                                $(container).find('.full_price').html($(container).find('.full_price').html() + period);
                            }
                        }
                    }
                },
                cache: false,
                // по хорошему избавиться от синхронности
                async: false
            };
            $.ajax(ajax_obj);
        }
    }
    return false;
}

window.update_cart_item = function(elem) {
    if ($(elem).is(':disabled')) {
        return;
    }
    var error = 0;
    var container = $(elem).parents('.cart_item_list_wrapper');
    var form_wrapper = $(elem).parents('.cart_list_form');
    var data = {};
    data.amount = parseInt($(container).find('.amount_field').val());
    data.sub_amount = parseInt($(container).find('.sub_amount_field').val());
    data.partner = $(form_wrapper).find('.partner').val();
    data.item_id = $(container).find('.item_id').val();

    data.item_type = $(container).find('.item_type').val();
    data.item_sub_type = $(container).find('.item_sub_type').val();
    data.date_from = $(container).find('.date_start').val();
    data.date_to = $(container).find('.date_end').val();
    if ($(form_wrapper).find('.cart_token').val()) {
        data.h = $(form_wrapper).find('.cart_token').val();
    }
    if ($(form_wrapper).find('.user_token').val()) {
        data.user_token = $(form_wrapper).find('.user_token').val();
    }
    const pickupStoreInput = $(form_wrapper).find('[name="pickup_store"]');
    if (!pickupStoreInput.closest('.without_delivery').hasClass('nod') && pickupStoreInput.val()) {
        data.pickup_store = pickupStoreInput.val();
    }
    const pickupPvzInput = $(form_wrapper).find('[name="pickup_pvz"]:checked');
    if (pickupPvzInput.closest('.without_delivery').hasClass('is-active') && pickupPvzInput.val()) {
        data.pickup_pvz = pickupPvzInput.val();
    }
    const pickupPosInput = $(form_wrapper).find('[name="pickup_pvz"]:checked');
    if ($(form_wrapper).find('.in_pos').hasClass('is-active')) {
        data.is_pos = 1;
    } else if ($(form_wrapper).find('.without_delivery').hasClass('is-active')) {
        data.is_pvz = 1;
    }
    if (pickupPosInput.closest('.in_pos').hasClass('is-active') && pickupPosInput.val()) {
        data.pickup_pvz = pickupPosInput.val();
    }
    const delayedFns = [];
    if (data.is_pos && !data.pickup_pvz) {
        const firstOption = $(form_wrapper).find('.in_pos').find('[name="pickup_pvz"]:first');
        delayedFns.push(() => firstOption.click());
    }
    if (data.is_pvz && !data.pickup_pvz) {
        const firstOption = $(form_wrapper).find('.without_delivery').find('[name="pickup_pvz"]:first');
        delayedFns.push(() => firstOption.click());
    }
    $('.order_button').attr('disabled', false);
    if (data.amount > 0 && data.item_id && data.date_from == data.date_to && data.item_type != "sub" && data.item_sub_type != "iqos_install" && data.item_sub_type != "iqos_test" && data.item_sub_type != "sub") {
        error = 1;
        $(container).find('.date-range').addClass('is-error');
        $('.order_button').attr('disabled', true);
    }

    if (data.item_type == 'arenda' && data.item_sub_type == "sub") {
        if (data.amount > 12) {
            data.amount = 12;
        }
        $(container).find('.amount_field').val(data.amount);
    }

    data.delivery = [];
    data.variant = [];
    data.time = [];
    var i = 0;
    $('.cart_delivery_item_wrapper').each(function () {
        data.delivery[i] = $(this).find('.cart_stamp').val();
        data.variant[i] = $(this).find('.cart_delivery_variant').val();
        data.time[i] = $(this).find('.cart_delivery_time').val();
        i++;
    });
    if (data.item_type === 'sub') {
        if (data.amount > 6) {
            data.amount = 6;
        }
        $(container).find('.amount_field').val(data.amount);
    }

    if (data.item_type === "complect") {
        var complect_type = $(container).find('.item_type_id').val();

        if (complect_type == 2) {
            var products = [];
            var p = 0;
            $(container).find('.complect_primary_product_slot').each(function () {
                var product = $(this).find('.product_id');

                if ($(product).val() > 0) {
                    products[p] = $(product).val();
                    p++;
                }
            });
            data.products = products;
        }

        if (complect_type == 1) {
            var products = [];
            var counts = [];
            var p = 0;

            $(container).find('.complect_product_list_wrapper').each(function () {
                var product = $(this).find('.count_in_complect');
                var name = $(product).attr('name');
                var tmp = name.split('[');
                var tmp = tmp[1].split(']');
                if ($(product).val() > 0) {
                    products[p] = tmp[0];
                    counts[p] = $(product).val();
                    p++;
                }
            });
            data.products = products;
            data.counts = counts;
        }
    }

    data.is_company = $(form_wrapper).find('.company_check').val();
    data.payment_type = 0;

    $(form_wrapper).find('.payment_type').each(function () {
        if ($(this).prop('checked')) {
            data.payment_type = $(this).val();
        }
    });
    $('.cart_card_list').addClass('nod');
    if (data.payment_type == 0) {
        $('.cart_card_list').removeClass('nod');
    }
    $('.cart_card_pay_attention').addClass('nod');
    if (data.payment_type == 0) {
        $('.cart_card_pay_attention').removeClass('nod');
    }

    var ajax_obj = {
        url: '/cart/update/',
        type: 'post',
        beforeSend: function () {
            $(container).find('.products_sum_format').html('<img src="/assets/images/loader.gif" class="loader">');
            $('.cart_all_sum').html('<img src="/assets/images/loader.gif" class="loader">');
            $('.all_sum_old').html('');
            $(container).find('.first_price_format').html('<img src="/assets/images/loader.gif" class="loader">');
            //$(container).find('.first_price_format').parent().addClass('nod');
            $(container).find('.buy_price_wrapper').addClass('nod');
            $(container).find('.delta_wrapper').addClass('nod');
        },
        data: data,
        dataType: 'json',
        complete: function (answer) {
            if (answer.responseText) {
                if (data.is_pos) {
                    const templatesByPlace = {
                        '[data-current-pos-outer]' : (pvz) => `<strong>${pvz.name} ${pvz.address}</strong>`,
                        '[data-current-pvz-outer]' : () => `<strong>выберите ПВЗ</strong>`,
                        ...(window.additionalPlaces ?? {}),
                    };
                    if (data.pickup_pvz) {
                        window.updatePvzMap(data.pickup_pvz ?? '', templatesByPlace);
                    }
                    window.posCurrent = data.pickup_pvz ?? '';
                    if (window.posCurrent) {
                        window.posObjectManager.objects.balloon.open(window.posCurrent);
                    }
                    window.additionalPlaces = {};
                } else {
                    const templatesByPlace = {
                        '[data-current-pvz-outer]' : (pvz) => `<strong>${pvz.name} ${pvz.address}</strong>`,
                        '[data-current-pos-outer]' : () => `<strong>выберите постамат</strong>`,
                        ...(window.additionalPlaces ?? {}),
                    };
                    if (data.pickup_pvz) {
                        window.updatePvzMap(data.pickup_pvz ?? '', templatesByPlace);
                        window.pvzCurrent = data.pickup_pvz ?? '';
                        if (window.pvzCurrent) {
                            window.objectManager.objects.balloon.open(window.pvzCurrent);
                        }
                        window.additionalPlaces = {};
                    }
                }

                $(container).find('.products_sum_format').html('');
                $('.cart_all_sum').html('');
                $('.old_sum').html('');
                $('.discount_sum').html('');
                $(container).find('.sum_field').val(0);
                try {
                    res = eval('(' + answer.responseText + ')');
                } catch (err) {
                }

                if (res.only_card_payment) {
                    $('.payment_type_button.without_delivery111 .payment_type').prop('selected', true);
                    $('.payment_type_button.with_delivery .payment_type').prop('selected', true);
                    $('.payment_type_button.with_delivery').addClass('nod');
                } else {
                    if (data.variant[0] == 0) {
                        $('.payment_type_button.with_delivery').removeClass('nod');
                    }
                }

                $('.minsum-message').addClass('nod');
                if (res.min_amount) {
                    $('.minsum-message').removeClass('nod');
                    if (res.min_amount_compact) {
                        $('.min_sum_error').html(res.min_amount_compact);
                    }
                }
                $('.delta_wrapper').addClass('nod');
                if (res.delta) {
                    $('.delta').html(res.delta_format);
                    $('.delta_wrapper').removeClass('nod');
                }
                if (res.agree_cart_text) {
                    $('.agree_cart_text').html(res.agree_cart_text);
                }

                $('.iqos_form').removeClass('no_only_iqos_in_cart');
                if (res.no_only_iqos) {
                    $('.iqos_form').addClass('no_only_iqos_in_cart');
                }

                if (res.sum) {
                    $(container).find('.sum_field').val(res.sum);
                }
                if (res.delivery_html && res.delivery_type === 'delivery') {
                    $('.delivery_list_wrapper').html(res.delivery_html);
                    $('.delivery_list_wrapper').find('.selectstyle').each(function (i) {
                        window.update_select_style(this);
                        // выше уже повесили слушатель на body, так что все добавленные элементы попадут тоже
                        /*$('.cart_param_list').on('click', function () {
                            return set_cart_param(this);
                        });*/
                    });
                }

                $('.cart_item_list').each(function () {
                    if ($(this).find('.date_start').length > 0) {
                        $(this).find('.date-range').attr('data-min-period', res.min_period);
                        $(this).find('.date-range').data('min-period', res.min_period);
                    }
                });

                $('.date-range').each(function () {
                    const picker = $(this).parents('.date-wrapper').find('.date-picker-wrapper');
                    picker.remove();
                    if ($(this).hasClass('is_delivery_list')) {
                        return;
                    }
                    if (res.today_available) {
                        $(this).data('min-day', moment().format('YYYY-MM-DD'));
                        $(this).attr('data-min-day', moment().format('YYYY-MM-DD'));
                    } else {
                        $(this).data('min-day', moment().add(1, 'day').format('YYYY-MM-DD'));
                        $(this).attr('data-min-day', moment().add(1, 'day').format('YYYY-MM-DD'));
                    }
                    const uid = $(this).attr('id').replace(/\D/g,'')
                    const dateStart = res.item_date[uid];
                    if ($(this).data('type') === 'daily') {
                        const dateEnd = res.item_date_end[uid];
                        const period = moment(dateStart, 'DD.MM.YYYY').format('DD MMM') + '<i class="datepicker__icon-sep"></i>' + moment(dateEnd, 'DD.MM.YYYY').format('DD MMM');
                        $(this).find('.datepicker__data').html(period);
                        $(this).find('.date_start').val(dateStart);
                        $(this).find('.date_end').val(dateEnd);
                    } else {
                        if (dateStart) {
                            const period = moment(dateStart, 'DD.MM.YYYY').format('DD MMM');
                            $(this).find('.datepicker__data').html(period);
                            $(this).find('.date_start').val(dateStart);
                        }
                    }

                    /*if (res.date_changed) {
                        $(this).find('.datepicker__data').html(moment().add(1, 'day').format('DD MMM'));
                    } else if (res.date_today) {
                        $(this).find('.datepicker__data').html(moment().format('DD MMM'));
                    }*/
                });
                window.set_range_picker_all();
                if (res.periods_changed) {
                    $('.cart_item_list').each(function () {
                        if ($(this).find('.date_start').length > 0) {
                            window.update_cart_item($(this).find('.date_start'));
                        }
                    });
                }
                if (res.delivery_tabs) {
                    $('.delivery_tabs_wrapper').html(res.delivery_tabs);
                }
                const rubValues = {
                    muztorg: ' р.',
                    skifmusic: ' р.',
                    mts: ' ₽',
                    svyaznoy: ' ₽',
                    kant: ' ₽',
                };
                var rub = data.partner
                    ? (rubValues[data.partner] ?? ' ₽')
                    : ' <span class="currency-decorated">₽</span>';

                if (res.products_sum_format) {
                    if (!$(container).find('.products_sum_format').hasClass('no_descr')) {
                        res.products_sum_format += rub;
                    }
                    $(container).find('.products_sum_format').html(res.products_sum_format);
                }

                if (res.days) {
                    $(container).find('.product_days').html(res.days);
                }
                if (res.days_descr) {
                    $(container).find('.product_days_descr').html(res.days_descr);
                }
                if (res.average) {
                    if (!$(container).find('.first_price_format').hasClass('no_descr')) {
                        res.average += rub;
                    }
                    $(container).find('.first_price_format').html(res.average);
                    $(container).find('.first_price_format').parent().removeClass('nod');
                }

                if (res.potential) {
                    $(container).find('.potential_price_format').html(res.potential + ' ' + rub);
                    $(container).find('.potential_price_format').parent().removeClass('nod');
                }

                if (res.period && (data.item_type == 'sub' || (data.item_type == 'arenda' && (res.sub_type == 'sub' || res.sub_type == 'sub_fix' || res.sub_type == 'sub_fix_week')))) {
                    $(container).find('.period').html(res.period);
                    $(container).find('.period').parent().removeClass('nod');
                }

                $('.min_order_error').remove();
                $('.order_button').removeClass('is-disabled');
                $('.common_error').removeClass('alert-message').html('');
                $('.near_button_error').removeClass('alert-message').removeClass('mbot20').html('');
                if (res.min_amount) {
                    $('.common_error').html(res.min_amount).addClass('alert-message');
                    $('.near_button_error').html(res.min_amount);
                    $('.near_button_error').addClass('alert-message').addClass('mbot20');
                    $('.order_button').addClass('is-disabled');
                }

                if (res.all_sum) {
                    $('.cart_all_sum').html(res.all_sum + ' ' + rub);
                }
                $('.old_sum').html('');
                if (res.all_old_sum) {
                    $('.all_sum_old').html(res.all_old_sum + ' ' + rub);
                }
                $('.all_sum_old').html('');

                res.old_sum_format = res.old_sum_format ?? 0;
                $('.old_sum').html(res.old_sum_format + ' ' + rub);

                res.discount_sum_format = res.discount_sum_format ?? 0;
                $('.discount_sum').html(res.discount_sum_format = '-' + res.discount_sum_format + ' ' + rub);

                res.delivery_sum_format = res.delivery_sum_format ?? 0;
                $('.delivery_sum').html(res.delivery_sum_format + ' ' + rub);
                if (!res.delivery_sum_format) {
                    $('.delivery_sum').html('Бесплатно');
                }

                if (res.iqos_here) {
                    $('.delivery_sum').html('Бесплатно');
                }

                $('.insuranse_block').removeClass('nod');
                if (res.no_insuranse) {
                    $('.insuranse_block').addClass('nod');
                }

                $('.insurance_wrapper').addClass('nod');
                if (res.insurance_sum_format) {
                    $('.insurance_wrapper').removeClass('nod');
                    $('.insurance_sum').html(res.insurance_sum_format);
                }

                if (res.bonus_sum_format) {
                    $('.bonus_discount_sum').html(res.bonus_sum_format = '-' + res.bonus_sum_format + ' ' + rub);
                    $('.bonus_discount_wrapper').removeClass('nod');
                    $('.bonus_count_field').val(res.bonus_sum);
                } else {
                    $('.bonus_discount_sum').html('0 ' + rub);
                    $('.bonus_discount_wrapper').addClass('nod');
                    $('.bonus_count_field').val('');
                }

                if (res.order_bonus_sum_format) {
                    $('.order_bonus_sum').html(res.order_bonus_sum_format + ' ' + rub);
                    $('.bonus_add_wrapper').removeClass('nod');
                } else {
                    $('.order_bonus_sum').html('0 ' + rub);
                    $('.bonus_add_wrapper').addClass('nod');
                }

                $(container).find('.buy_price_wrapper').addClass('nod');
                if (res.buy_count) {
                    $(container).find('.buy_price_wrapper').removeClass('nod');
                    $(container).find('.buy_count').html('Кол-во: ' + res.buy_count + ' шт.');
                    if (res.buy_sum_format) {
                        $(container).find('.buy_price').html('+' + res.buy_sum_format + ' ' + rub);
                    }
                }
            }

            if (res.containers) {
                for (property in res.containers) {
                    var after = '';
                    if ($(form_wrapper).find('.cart_date_wrapper_' + property).length == 0) {
                        $(form_wrapper).find('.cart_date_wrapper').each(function () {
                            if ($(this).find('.item_stamp').val() < property) {
                                after = $(this).find('.item_stamp').val();
                            }
                        });

                        if (after) {
                            $(form_wrapper).find('.cart_date_wrapper_' + after).after(res.containers[property]);
                        } else {
                            $(res.containers[property]).prependTo($(form_wrapper).find('.order_list_wrapper'));
                        }
                        // пока сделали единые доставки
                        const newDateText = $(res.containers[property]).find('.order-list__date-title').html();
                        $(form_wrapper).find('.order-list__date-title').html(newDateText);
                    }
                }
            }

            if (res.item_date) {
                for (property in res.item_date) {
                    $(form_wrapper).find('.order_list_wrapper').find('.cart_item_list').each(function () {
                        if ($(this).find('.item_id').val() == property) {
                            $(this).find('.item_stamp').val(res.item_date[property]);
                            var block = $(this).parents('.cart_item_list_wrapper');
                            var date_wrapper = $(this).parents('.cart_date_wrapper');
                            if (!$(date_wrapper).hasClass('.cart_date_wrapper_' + res.item_date[property])) {
                                $(block).appendTo($(form_wrapper).find('.cart_date_wrapper_' + res.item_date[property]));
                            }
                        }
                    });
                }
            }
            if (res.items) {
                for (property in res.items) {
                    $(form_wrapper).find('.order_list_wrapper').find('.cart_item_list').each(function () {
                        if ($(this).find('.item_id').val() == property) {
                            const oldCount = $(this).find('.qty-box__input').val();
                            $(this).find('.qty-box__input').val(res.items[property].count);
                            $(this).find('.limit-notification').remove();
                            if (oldCount > res.items[property].count) {
                                $(this).find('.qty-box').after($('<div class="limit-notification" style="color:#ff0f0f">Количество данного товара ограничено к аренде</div>'))
                            }
                        }
                    });
                }
            }
            $('.cart_popup_wrapper').html('');
            if (res.cart_popup) {
                $('.cart_popup_wrapper').html(res.cart_popup);
            }

            $(form_wrapper).find('.order_list_wrapper').find('.cart_date_wrapper').each(function () {
                $(this).find('.cart_item_list').each(function () {
                    if ($(this).find('.amount_field').val() == 0) {
                        $(this).parents('.cart_item_list_wrapper').remove();
                    }
                });
                if ($(this).find('.cart_item_list').length == 0) {
                    $(this).remove();
                }
            });
            if ($(form_wrapper).find('.order_list_wrapper').find('.cart_date_wrapper').length == 0) {
                $('.cart_amount').addClass('nod');
                $(form_wrapper).find('.full_cart_wrapper').remove();
                $(form_wrapper).find('.empty_cart_wrapper').removeClass('nod');
            } else {
                if (parseInt(res.all_count) > 0) {
                    $('.cart_amount').html(res.all_count).removeClass('nod');
                }
                //check_delivery();
                get_compact_list();
            }
            if (need_show_cart_popup == 1) {
                $('.js-popup-cart').mouseover();
            }
            need_show_cart_popup = 0;
            delayedFns.forEach((fn) => fn());
        },
        cache: false,
        async: true
    };

    if (!error) {
        $.ajax(ajax_obj);
    }
}

function set_card_popup(elem)
{
    if (elem)
    {
        var card_id=$(elem).attr('card_id');
        $('#popup-card-del').find('.delete_link').attr('href', '/profile/cards/delete/'+card_id);
    }
}

window.set_time_slider = function (elem) {
    if (elem) {
        const elem_id = $(elem).attr('id');

        var wrapper = $(elem).parents('.timeslider');
        var slider = document.getElementById(elem_id);
        var start = $(wrapper).find('.js-timeslider-input').val();
        const values = $(wrapper).find('.js-timeslider-input').data('values') ?? [1,2,3,6,12];
        const period = $(wrapper).find('.js-timeslider-input').data('period') ?? 'мес.';
        var obj = {
            start: [start],
            //step: 1,
            range: {
                'min': values[0],
                '26%': values[1],
                '50%': values[2],
                '75%': values[3],
                'max': values[4],
            },
            snap: true,
            format: {
                to: function (value) {
                    return parseInt(value) + `<span>${period}</span>`;
                },
                from: function (value) {
                    return parseInt(value);
                }
            },
            tooltips: true,
        };

        if (timeslider[elem_id] === undefined) {
            timeslider[elem_id] = noUiSlider.create(slider, obj);

            slider.noUiSlider.on('change', function (values, handle, unencoded, tap, positions) {
                var newVal = Math.round(unencoded);
                slider.noUiSlider.set(newVal);
                $(wrapper).find('.js-timeslider-input').val(newVal);
                if ($(wrapper).hasClass('is_cart_list') || $(elem).hasClass('is_cart_list')) {
                    window.update_cart_item(elem);
                }
                if ($(wrapper).hasClass('is_product')) {
                    window.update_cart_form(elem);
                }
                if ($(wrapper).hasClass('is_order')) {
                    $('.order_price').addClass('nod');
                    $('.order_price_' + newVal).removeClass('nod');
                }
            });
        }
    }
}

window.set_range_picker_all = function()
{
    $('.date-range').each(function () {
        var picker = $(this).parents('.date-wrapper').find('.date-picker-wrapper');

        if (!picker.length) {
            window.set_range_picker(this);
        }
    });
    const datepickerInit = ($el) => $el.dateRangePicker({
        autoClose: true,
        language: 'ru',
        format: 'DD MMM',
        startOfWeek: 'monday',
        startDate: $el.data('start-date') ? moment($el.data('start-date'), 'DD.MM.YYYY').toDate() : new Date(),
        hoveringTooltip: false,
        stickyMonths: true,
        inline: true,
        container: $el.parent(),
        separator: '<i class="datepicker__icon-sep"></i>',
        singleMonth: $el.data('type') === 'single',
        singleDate: $el.data('type') === 'single',
        getValue: function () {
            return $el.find('.datepicker__data').html();
        },
        setValue: function (s) {
            $el.find('.datepicker__data').html(s);
        },
    }).bind('datepicker-open', function () {
        $el.addClass('is-open');
    }).bind('datepicker-closed', function () {
        $el.removeClass('is-open');
    }).bind('datepicker-change', function (event, obj) {
        const start_date = moment(obj.date1).format('DD.MM.YYYY');
        $el.find('input').first().val(start_date);
        $el.find('input').first().trigger('change');
    });
    const datepickers = $('.datepicker.datepicker-special');
    datepickers.each(function(index, el) {
        datepickerInit($(el));
    });
}

window.set_range_picker = function (elem) {
    if (!elem) {
        return;
    }
    const elem_id = $(elem).attr('id');

    var wrapper1 = $('#' + elem_id);
    var wrapper2 = $('.' + elem_id);
    var wrapper = $(elem).parents('.date-wrapper');
    var wrapper3 = $(elem).parents('.date-wrapper-week');

    var myDate = new Date();
    var start_day = 0;
    if ($('.no_today').text()) {
        start_day = $('.no_today').text();
    }
    var start = myDate.getTime() + start_day * 86400000;

    //var end = myDate.getTime()+(start_day+15)*86400000;
    var obj = {
        autoClose: true,
        language: 'ru',

        minDays: 3,
        startOfWeek: 'monday',
        hoveringTooltip: function (days) {
            nights = days - 1;
            if (nights < 2) {
                return "Аренда доступна от 2 суток";
            }
            return nights + ' суток';
        },


        setValue: function (s, startDate, endDate) {
            if ($(elem).hasClass('single')) {
                s = s.split('<');
                s = s[0];

                $(wrapper).find('.datepicker__data').html(s);
                $(wrapper).find('.datepicker__date1').val(startDate);
                $(wrapper).find('.datepicker__date2').val(endDate);

                $(wrapper3).find('.datepicker__data').html(s);
                $(wrapper3).find('.datepicker__date1').val(startDate);
                $(wrapper3).find('.datepicker__date2').val(endDate);
            } else {
                $(wrapper1).parents('.cart_item_list').find('.delivery_descr').html(startDate);
                $(wrapper1).find('.datepicker__data').html(s);
                $(wrapper1).find('.datepicker__date1').val(startDate);
                $(wrapper1).find('.datepicker__date2').val(endDate);

                $(wrapper2).find('.datepicker__data').html(s);
                $(wrapper2).find('.datepicker__date1').val(startDate);
                $(wrapper2).find('.datepicker__date2').val(endDate);
            }
            if ($(elem).is('[data-change-button]')) {
                $(elem).closest('form').find('.not-in-list span').text('Забронировать');
                $(elem).closest('form').find('.in-list,.not-in-list').removeClass('_secondary').addClass('_green');
            }
        },
        customOpenAnimation: function(cb)
        {
            $(this).fadeIn(0, cb);
        },
        customCloseAnimation: function(cb)
        {
            $(this).fadeOut(0, cb);
        },
        inline: true,
        stickyMonths: true,
        beforeShowDay: function (d) {
            return [true];
            //var dat = moment(d).format('MM-DD');
            //if (dat != '01-01' && dat != '01-02') {return [true];} else {return [false];}
        },
    };

    if (!$(elem).hasClass('mustorg_iframe_product')) {
        obj.format = 'DD MMM';
        obj.separator = '<i class="datepicker__icon-sep"></i>';
        if ($(elem).hasClass('mts')) {
            obj.separator = ' -> ';
        }
        if ($(elem).hasClass('svyaznoy')) {
            obj.separator = ' -> ';
        }
        if ($(elem).hasClass('kant')) {
            obj.separator = ' -> ';
        }
        if ($(elem).hasClass('muztorg')) {
            obj.separator = ' -> ';
        }
        if ($(elem).hasClass('skifmusic')) {
            obj.separator = ' -> ';
        }
        obj.getValue = function () {
            const val = $(this).find('.datepicker__data').html();
            const finalVal = val.replace(/[^\s\d\wа-яА-Я<>"=\-\\/]/g,'').trim().replaceAll(/\s{2,}/g,' ');
            const parts = finalVal.split(obj.separator);
            if (parts[0] && parts[1] === '' && $(elem).data('pos-allowed-today')) {
                parts[1] = moment().subtract(1, 'd').format(obj.format);
            }
            return parts.join(obj.separator);
        }
    }
    if ($(elem).find('.date_name').val() == 'profile_card_history') {
        obj.separator = ' - ';
    }
    obj.minDay = 1;

    if ($(elem).parents('.date-wrapper').length > 0) {
        obj.container = '.date-wrapper';
    }
    if ($(elem).parents('.cart_item_list').find('.item_id').val()) {
        obj.container = '.date-wrapper-' + $(elem).parents('.cart_item_list').find('.item_id').val();
    }

    if ($(elem).parents('.cart_delivery_item_wrapper').find('.cart_delivery_stamp').val()) {
        obj.container = '.date-wrapper-' + $(elem).parents('.cart_delivery_item_wrapper').find('.cart_delivery_stamp').val();
    }

    if ($(elem).hasClass('full_month')) {
        obj.format = 'D MMMM';
    }
    if ($(elem).hasClass('single')) {
        obj.singleMonth = true;
        obj.singleDate = true;
    }
    if ($(elem).hasClass('showtopbar')) {
        obj.showTopbar = false;
    }
    //obj.endDate = new Date(end);
    if (!$(wrapper1).hasClass('only_before') && !$(wrapper1).hasClass('all_date')) {
        obj.startDate = new Date(start);
    }
    if ($(wrapper1).hasClass('only_before') && !$(wrapper1).hasClass('all_date')) {
        obj.endDate = new Date(myDate.getTime());
    }
    if ($(elem).is('[data-min-day]')) {
        const startDate = $(elem).data('min-day');
        obj.startDate = new Date(startDate);
    }
    const today = new Date();
    const cDate = today.getDate();
    const cMonth = today.getMonth();
    const cYear = today.getFullYear();
    today.setUTCHours(3, 0, 0, 0);
    today.setUTCMonth(cMonth);
    today.setUTCFullYear(cYear);
    today.setUTCDate(cDate);
    const tomorrow = new Date();
    const tDate = tomorrow.getDate();
    const tMonth = tomorrow.getMonth();
    const tYear = tomorrow.getFullYear();
    tomorrow.setUTCHours(3, 0, 0, 0);
    tomorrow.setUTCMonth(tMonth);
    tomorrow.setUTCFullYear(tYear);
    tomorrow.setUTCDate(tDate + 1);
    if ($(elem).is('[data-forbidden-days]')) {
        const forbiddenDays = $(elem).data('forbidden-days');
        obj.beforeShowDay = function (t) {
            const parsedTime = moment(t).format('DD.MM.YYYY');
            let localForbidden;
            if ($(elem).data('only-pos-today') && $(elem).data('dateRangePicker')) {
                const [start] = $(elem).data('dateRangePicker').getCurrentInterval();
                if (start) {
                    const startDate = new Date(start);
                    const cDate = startDate.getDate();
                    startDate.setUTCHours(3, 0, 0, 0);
                    startDate.setDate(cDate);
                    if (startDate.getTime() === today.getTime()) {
                        localForbidden = {};
                    }
                }
            }
            const disabledDates = Object.values(localForbidden ?? forbiddenDays);
            const valid = (disabledDates.indexOf(parsedTime) === -1);
            const _class = '';
            const _tooltip = valid ? '' : 'В этот день товар занят';
            return [valid, _class, _tooltip];
        };
    }
    if ($(elem).is('[data-min-period]')) {
        const minPeriod = $(elem).data('min-period');
        obj.minDays = minPeriod + 1;
        obj.hoveringTooltip = (days, _1, _2, minDays) => {
            const nights = days - 1;
            if (nights < minDays - 1) {
                return `Аренда доступна от ${minDays - 1} суток`;
            }
            return nights + ' суток';
        };
        $.dateRangePickerLanguages['ru']['more-than'] = `Аренда минимум ${minPeriod} дня`;
        $.dateRangePickerLanguages['ru']['default-more'] = `Аренда минимум ${minPeriod} дня`;
    }


    if ($(elem).hasClass('single')) {
        obj.single = true;
    }
    const timeAfter1430 = myDate.getHours() > 14 || (myDate.getHours() === 14 && myDate.getMinutes() >= 30);
    if ($(elem).hasClass('muztorg') && !$(elem).hasClass('muztorg-today')) {

        obj.startDate = new Date(myDate.getTime() + 86400000);
        if (timeAfter1430) {
            obj.startDate = new Date(myDate.getTime() + 2 * 86400000);
        }
    }
    if ($(elem).hasClass('muztorg')) {
        obj.singleMonth = true;
    }

    if ($(elem).hasClass('mts')) {

        obj.startDate = new Date(myDate.getTime() + 86400000);
        if (timeAfter1430) {
            obj.startDate = new Date(myDate.getTime() + 2 * 86400000);
        }
    }

    if ($(elem).hasClass('svyaznoy')) {

        obj.startDate = new Date(myDate.getTime() + 86400000);
        if (timeAfter1430) {
            obj.startDate = new Date(myDate.getTime() + 2 * 86400000);
        }
    }

    if ($(elem).hasClass('kant')) {

        obj.startDate = new Date(myDate.getTime() + 86400000);
        if (timeAfter1430) {
            obj.startDate = new Date(myDate.getTime() + 2 * 86400000);
        }
    }

    if ($(elem).hasClass('skifmusic')) {

        obj.startDate = new Date(myDate.getTime() + 86400000);
        if (timeAfter1430) {
            obj.startDate = new Date(myDate.getTime() + 2 * 86400000);
        }
    }
    var did = $(elem).attr('id');
    if (!did) {
        did = 0;
    }
    if ($(elem).hasClass('mustorg_iframe_product')) {
        obj.alwaysOpen = true;
        obj.inline = true;
        //obj.separator = '';
        //obj.container = $('#container_'+elem_id);

    }
    const getDayPrice = (firstDate, time, priceArr) => {
        const now = moment(firstDate);
        const datetime = moment(time).startOf('day');
        const diff = datetime.diff(now, 'days');

        if (diff < 0) {
            return '';
        }
        if (!priceArr) {
            return '';
        }
        if (diff == 0) {
            return '&nbsp;';
        } else if (diff > 0 && diff <= 1) {
            return priceArr[0];
        } else if (diff > 1 && diff <= 2) {
            return priceArr[1];
        } else {
            return priceArr[2];
        }
    };
    if ($(elem).data('startday') && Number($(elem).data('min-period')) === 2) {
        obj.firstDate = moment($(elem).data('startday'),'DD.MM.YYYY').toDate();
    } else {
        if (Number($(elem).data('min-period')) === 1 && $(elem).data('min-day')) {
            obj.firstDate = moment($(elem).data('min-day'),'YYYY-MM-DD').toDate();
        } else {
            obj.firstDate = new Date();
        }
    }

    obj.firstDate.setHours(0, 0, 0, 0);
    obj.showDateFilter = function(object, time, date) {
        let price = '';
        if ($(elem).data('type') !== 'single') {
            price = getDayPrice(object.firstDate, time, $(elem).data('prices'));
        }
        if ($(elem).data('only-pos-today')) {
            const thisDay = new Date(time);
            const curDate = thisDay.getDate();
            thisDay.setUTCHours(3, 0, 0, 0);
            thisDay.setUTCDate(curDate);
            if (thisDay.getTime() === today.getTime() && Number($(elem).data('min-period')) === 2) {
                // price = 'пост-т';
            }
        }
        return '<div class="date-picker-cell">\
                  <span class="date-picker-day">'+date+'</span>\
                  <div class="date-picker-price">'+price+'</div>\
                </div>';
    }

    var dexample = obj;
    if ($(elem).data('dateRangePicker')) {
        $(elem).data('dateRangePicker').destroy();
    }
    const dpChange = function (event, obj) {
        if (!$(elem).hasClass('single')) {
            var end_date = moment(obj.date2).format('DD.MM.YYYY');
            $(this).find('.date_end').val(end_date);
            $(wrapper1).find('.date_end').val(end_date).trigger('change');
            $(wrapper2).find('.date_end').val(end_date).trigger('change');
            $(wrapper).find('.date_end').val(end_date).trigger('change');
            $(fix_container).find('.date_end').val(end_date);
            $(elem).data('startday', moment(obj.date1).format('DD.MM.YYYY'));
            $('.tooltip-to-hide').hide();
        }
        var start_date = moment(obj.date1).format('DD.MM.YYYY');
        $(wrapper1).find('.date_start').val(start_date).trigger('change');
        $(wrapper2).find('.date_start').val(start_date).trigger('change');
        $(wrapper).find('.date_start').val(start_date).trigger('change');
        var fix_container = $('.product-fixed .arenda_wrapper');
        $(fix_container).find('.date_start').val(start_date);
        if ($(elem).hasClass('single')) {
            $(this).parents('.date-wrapper').find('.date_start').val(start_date).trigger('change');
        }
        $(this).find('.date_start').val(start_date);

        $(this).find('.date_wrapper').removeClass('is-error');

        if ($(wrapper1).hasClass('is_cart_list')) {
            $('.delivery_list_wrapper .date_start').val(start_date);
        }

        if ($(this).hasClass('mustorg_iframe_product')) {
            window.update_cart_item($(wrapper).find('.date_start'));
        }
        if ($(wrapper1).hasClass('is_delivery_list') || $(wrapper1).hasClass('is_cart_list')) {
            var new_date = $(this).find('.date_start').val();
            var old_date = $(this).find('.date_start_old').val();

            $('.cart_item_list').each(function () {

                if ($(this).find('.date_start').length > 0) {
                    var item_end_date = $(this).find('.date_end').val();
                    var item_start_date = $(this).find('.date_start').val();

                    if (item_start_date == old_date || item_start_date != old_date) // Меняем дату у всех!
                    {
                        $(this).find('.date_start').val(new_date).trigger('change');

                        if ($(this).find('.datepicker').hasClass('single')) {
                            $(this).find('.datepicker__data').html(moment(new_date, 'DD.MM.YYYY').format(dexample.format));
                        }
                        if (!$(this).find('.datepicker').hasClass('single')) {
                            var old_start_stamp = moment(item_start_date, 'DD.MM.YYYY').valueOf();
                            var old_end_stamp = moment(item_end_date, 'DD.MM.YYYY').valueOf();
                            var day_count = parseInt((old_end_stamp - old_start_stamp) / 86400000);

                            var date_html = moment(new_date, 'DD.MM.YYYY').format(dexample.format);
                            date_html += dexample.separator;
                            date_html += moment(new_date, 'DD.MM.YYYY').add(day_count, 'd').format(dexample.format);

                            $(this).find('.date_end').val(moment(new_date, 'DD.MM.YYYY').add(day_count, 'd').format('DD.MM.YYYY'));
                            $(this).find('.datepicker__data').html(date_html);

                        }

                        $(this).find('.delivery_descr').html(moment(new_date, 'DD.MM.YYYY').format(dexample.format));
                        window.update_cart_item($(this).find('.date_start'));
                    }
                }
            });
            //update_cart_item(elem);
        }
        if ($(wrapper1).hasClass('is_product')) {
            window.update_cart_form(elem);
        }

        if ($(elem).parents('.primary_complect_wrapper').length > 0) {
            check_primary_complect_product_count();
        }
    };
    const dpOpen = function (e) {
        $(this).addClass('is-open');
        check_calendar_position();
    };
    const dpClosed = function (event, obj) {
        $(this).removeClass('is-open');
    };
    const dpOpened = function (event, obj) {
        $(elem).data('prev-value', $(this).find('.datepicker__data').html());
        check_calendar_position();
    };
    const dpFirstSelected = function (event, obj) {
        const posCondition = $(elem).data('pos-allowed-today') || Number($(elem).data('min-period')) === 1;
        if ($(elem).data('dateRangePicker') && posCondition) {
            const startDate = new Date(obj.date1);
            const curDate = startDate.getDate();
            startDate.setUTCHours(3, 0, 0, 0);
            startDate.setUTCDate(curDate);
            const minPeriodDay = $(elem).data('pos-allowed-today') ? today : tomorrow;
            if (startDate.getTime() === minPeriodDay.getTime()) {
                $(elem).data('dateRangePicker').setMinDays(2);
            } else {
                const forbiddenDays = $(elem).data('forbidden-days');
                const parsedTime = moment(startDate).format('DD.MM.YYYY');
                const disabledDates = Object.values(forbiddenDays);
                const valid = (disabledDates.indexOf(parsedTime) === -1);
                if (!valid) {
                    const minDay = moment(startDate).format('DD MMM');
                    $.dateRangePickerLanguages['ru']['more-than'] = `Аренда с ${minDay} недоступна`;
                    $.dateRangePickerLanguages['ru']['default-more'] = `Аренда с ${minDay} недоступна`;
                    $(elem).data('dateRangePicker').clear();
                    $(this).find('.datepicker__data').html($(elem).data('prev-value'));
                } else {
                    if (Number($(elem).data('min-period')) === 1) {
                        if ($(elem).data('is-cart')) {
                            const minDay = moment(startDate).format('DD MMM');
                            $.dateRangePickerLanguages['ru']['more-than'] = `Для аренды с ${minDay} сначала выберите получение не в постамате`;
                            $.dateRangePickerLanguages['ru']['default-more'] = `Для аренды с ${minDay} сначала выберите получение не в постамате`;
                            $(elem).data('dateRangePicker').clear();
                            $(this).find('.datepicker__data').html($(elem).data('prev-value'));
                        } else {
                            $(elem).data('dateRangePicker').setMinDays(2);
                            $.dateRangePickerLanguages['ru']['more-than'] = `Аренда минимум 2 дня. Минимум 1 день<br> при самовывозе в постамате`;
                            $.dateRangePickerLanguages['ru']['default-more'] = `Аренда минимум 2 дня. Минимум 1 день<br> при самовывозе в постамате`;
                        }
                    } else {
                        $(elem).data('dateRangePicker').setMinDays(3);
                        $.dateRangePickerLanguages['ru']['more-than'] = `Аренда минимум 2 дня. Минимум 1 день<br> при самовывозе в постамате`;
                        $.dateRangePickerLanguages['ru']['default-more'] = `Аренда минимум 2 дня. Минимум 1 день<br> при самовывозе в постамате`;
                    }
                }

            }
        }

    };
    const currentDP = window.datepicker[did];
    if (currentDP) {
        currentDP.dp
            .unbind('datepicker-change', currentDP.change)
            .unbind('datepicker-open', currentDP.open)
            .unbind('datepicker-closed', currentDP.closed)
            .unbind('datepicker-opened', currentDP.opened)
            .unbind('datepicker-first-date-selected', currentDP.firstSelected);
    }
    window.datepicker[did] = {
        dp: $(elem).dateRangePicker(obj),
        change: dpChange,
        open: dpOpen,
        closed: dpClosed,
        opened: dpOpened,
        firstSelected: dpFirstSelected,
    };
    window.datepicker[did].dp
        .bind('datepicker-change', dpChange)
        .bind('datepicker-open', dpOpen)
        .bind('datepicker-closed', dpClosed)
        .bind('datepicker-opened', dpOpened)
        .bind('datepicker-first-date-selected', dpFirstSelected);
}



function check_calendar_position()
{
    return;
    if ($('.page__content').length > 0)
    {
        if (width < 400) {$(this).css('left', '-150px');}
        $('.date-picker-wrapper').each(function() {
            //if ($(this).width() > 200) {$(this).width('200px');}
            if ($(this).offset().left + $(this).width() > width)
            {
                var page_width = $('.page__content > .wrap').offset().left + $('.page__content > .wrap').width() - parseInt($('.page__content > .wrap').css('padding-right'));
                var new_left = parseInt($(this).offset().left - ($(this).offset().left + $(this).width() - page_width));
                console.log(new_left);
                $(this).css('left', new_left+'px');
            }
            if ($(this).offset().left < $('.page__content > .wrap').offset().left + parseInt($('.page__content > .wrap').css('padding-left')))
            {
                var new_left = $('.page__content > .wrap').offset().left + parseInt($('.page__content > .wrap').css('padding-left'));
                $(this).css('left', new_left+'px');

            }
        });
    }
}

function fastview_to_cart(elem)
{
    if (elem)
    {

        //$(elem).addClass('nod');
        data = new Object;
        data.url = '/cart/add/';
        data.type = $(elem).find('.item_type').val();
        data.id = $(elem).find('.item_id').val();
        data.amount = $(elem).find('.amount_field').val();
        data.date_start = $(elem).find('.date_start').val();
        data.date_end=$(elem).find('.date_end').val();
        if (!data.amount) {data.amount = 1;}
        if (!data.date_start) {data.date_start = moment().add('days', 1).format('DD.MM.YYYY');}
        if (!data.date_end) {data.date_end = moment().add('days', 2).format('DD.MM.YYYY');}
        data.no_async = 1;


        add_to_cart(elem, data);
        if ($(elem).hasClass('product_fixed_form')) {window.location.href='/cart/';}
        else {window.location.reload();}

    }
    return false;
}

function add_to_cart(elem, obj) {
    if (!elem) {
        return false;
    }
    var error = 0;
    var hei = $(elem).find('.product-simple__mobsection2').height();

    $(elem).find('.product-simple__mobsection2').css('height', hei + 'px');
    const data = {};
    data.amount = $(elem).find('.amount_field').val();
    data.type = $(elem).find('.item_type').val();
    data.sub_type = $(elem).find('.item_sub_type').val();
    data.id = $(elem).find('.item_id').val();
    data.mts_id = $(elem).find('.mts_item_id').val();
    data.svyaznoy_id = $(elem).find('.svyaznoy_item_id').val();
    data.kant_id = $(elem).find('.kant_item_id').val();
    data.month_price = $(elem).find('.day_price').text().replace(/[^0-9]/gi, '');
    data.full_price = data.amount * data.month_price;

    data.partner = $(elem).find('.partner').val();
    data.need_clear_cart = $(elem).find('.need_clear_cart').val();
    data.user_token = $(elem).find('.user_token').val();
    data.h = $(elem).find('.cart_token').val();
    const storeIdsInput = document.querySelector('.store_ids');
    if (storeIdsInput) {
        data.storeIds = JSON.parse(storeIdsInput.value);
    }

    if (
        (data.type == "arenda" && data.sub_type != "sub" && data.sub_type != "sub_fix" && data.sub_type != "sub_fix_week")
        || data.type == "wfree" || data.type == "complect" || data.type == "complect_primary"
    ) {
        data.date_start = $(elem).find('.date_start').val();
        data.date_end = $(elem).find('.date_end').val();
        if (obj) {
            for (property in obj) {
                data[property] = obj[property];
            }
        }
        if ($(elem).parents('.favorite_item_wrapper').length == 0) {
            if (!data.date_start || !data.date_end || data.date_start == data.date_end) {
                error = 1;
                $(elem).find('.date-range').addClass('is-error').click();
                var offset = $('.product-simple').offset();
                if (offset && offset.top > 0) {
                    $("body, html").animate({ "scrollTop": offset.top }, 'slow');
                }
            }
        }
        if (error == 0 && (!data.date_end || data.date_start == data.date_end)) {
            var tmp = moment($(elem).find('.date_start').val(), 'DD.MM.YYYY', true).add('days', 1);
            $(elem).find('.date_end').val(tmp.format('DD.MM.YYYY')).trigger('change');
            var full = moment($(elem).find('.date_start').val(), 'DD.MM.YYYY', true).format('DD MMM') + '<i class="datepicker__icon-sep"></i>' + tmp.format('DD MMM');
            $(elem).find('.datepicker__data').html(full);
            data.date_end = $(elem).find('.date_end').val();
            window.update_cart_form($(elem).find('.date_end'));
        }
        if (data.date_from == "01.01.2021" || data.date_from == "02.01.2021" || data.date_to == "01.01.2021" || data.date_to == "02.01.2021") {
            error = 1;
            $(container).find('.date-range').addClass('is-error');
            $('.order_button').attr('disabled', true);
        }
    }


    if (data.type === "arenda" && ['sub', 'sub_fix', 'sub_fix_week'].includes(data.sub_type)) {
        data.date_start = $(elem).find('.date_start').val();
    }

    if (data.type === "wfree") {
        data.primary_product = 0;
        $(elem).find('.complect_primary_product_wrapper').each(function () {
            if ($(this).find('.count_in_complect').val() > 0) {
                data.primary_product = $(this).find('.product_id').val();
            }
        });
        if (data.primary_product == 0) {
            error = 1;
            var offset = $($(elem).find('#primary_list')).offset();
            $("body, html").animate({ "scrollTop": offset.top }, 'slow');
        }
    }

    if (data.type === "complect_primary") {
        var products = [];
        var p = 0;
        $(elem).find('.complect_primary_product_slot').each(function () {
            var product = $(this).find('.product_id');

            if ($(product).val() > 0) {
                products[p] = $(product).val();
                p++;
            }
        });
        data.products = products;
    }

    if (data.type === "complect") {
        var products = [];
        var counts = [];
        var p = 0;
        $(elem).find('.complect_product_list_wrapper').each(function () {
            var product = $(this).find('.count_in_complect');

            var name = $(product).attr('name');
            var tmp = name.split('[');
            var tmp = tmp[1].split(']');
            if ($(product).val() > 0) {
                products[p] = tmp[0];
                counts[p] = $(product).val();
                p++;
            }
        });
        data.products = products;
        data.counts = counts;
    }

    if (data.type === "sub") {
        data.tariff_id = $(elem).find('.tariff_id').val();
        if (!data.tariff_id) {
            error = 1;
        }

        if (!$(elem).hasClass('is_cart')) {
            data.month_count = $('.month_count:checked').val();
            if (!data.month_count) {
                error = 1;
                $(elem).find('.month_count').parent().addClass('is-sub-error');
                $(elem).find('.month_count').each(function () {
                    $(this).parent().on('click', function () {
                        $('.month_label').removeClass('is-sub-error');
                    });
                });
            }
        }
        if ($(elem).hasClass('is_cart')) {
            data.month_count = $(elem).find('.month_count').val();
        }


        var max = $(elem).find('.max_item_count').val();
        var count1 = $(elem).find('.change_sub_product.add:not(.is_primary_product)').length;
        var count = count1;

        if ($(elem).hasClass('is_cart')) {
            var count2 = $(elem).find('.change_sub_product.in-list:not(.is_primary_product)').length;
            count += count2;
        }

        if (count != max) {
            error = 1;
            $(elem).find('.visible_in_sub').addClass('red');
        }
        var products = [];
        var p = 0;
        $(elem).find('.change_sub_product.add').each(function () {
            var product = $(this).parents('.button_wrapper').find('.product_in_sub');
            var name = $(product).attr('name');
            var tmp = name.split('[');
            var tmp = tmp[1].split(']');
            products[p] = tmp[0];
            p++;
        });
        if ($(elem).hasClass('is_cart')) {
            $(elem).find('.change_sub_product.in-list').each(function () {
                var product = $(this).parents('.button_wrapper').find('.product_in_sub');
                var name = $(product).attr('name');
                var tmp = name.split('[');
                var tmp = tmp[1].split(']');
                products[p] = tmp[0];
                p++;
            });
        }
        data.products = products;
    }

    if (error) {
        $(elem).find('.product-simple__mobsection2').css('height', 'auto');
        return false;
    }
    if (data.type === "sub" && $(elem).hasClass('is_cart')) {
        return true;
    }
    var url = $(elem).attr('action');

    if ($(elem).find('.url').val()) {
        url = $(elem).find('.url').val();
    }
    if (obj && obj.url) {
        url = obj.url;
    }

    const ecommEvents = () => {
        if ($('.ecom_products').html() || $(elem).hasClass('optional_product_wrapper') || $(elem).hasClass('fastview_add_to_cart')) {
            try {
                add_obj = {};
                add_obj.ecommerce = {};
                add_obj.ecommerce.currencyCode = "RUB";
                add_obj.ecommerce.add = {};
                add_obj.ecommerce.add.products = [];

                if ($('.ecom_products').html()) {
                    if (data.type !== 'complect') {
                        add_obj.ecommerce.add.products[0] = $.parseJSON($('.ecom_products').html());
                        for (i = 0; i < add_obj.ecommerce.add.products.length; i++) {
                            add_obj.ecommerce.add.products[i].quantity = 1;
                        }
                    }
                    if (data.type === 'complect') {

                        for (i = 0; i < products.length; i++) {
                            var prod = $.parseJSON($('.ecom_products.product_' + products[i]).html());

                            prod.quantity = counts[i];
                            add_obj.ecommerce.add.products[i] = prod;
                        }
                    }
                }

                if ($(elem).hasClass('optional_product_wrapper') || $(elem).hasClass('fastview_add_to_cart')) {
                    var optional_wrapper = $(elem);
                    var prod = new Object();
                    prod.id = $(optional_wrapper).find('.item_id').val();
                    prod.name = $(optional_wrapper).find('.item_name').val();
                    prod.brand = $(optional_wrapper).find('.brand_name').val();
                    prod.category = $(optional_wrapper).find('.category_name').val();
                    prod.price = $(optional_wrapper).find('.first_price').val();
                    add_obj.ecommerce.add.products[0] = prod;
                }
                ya_dataLayer.push(add_obj);
            } catch (err) {
                console.log(err);
            }
        }

        try {
            var push_data = $('.ecom_products').html();
            if ($('.ecom_complect').html()) {
                push_data = $('.ecom_complect').html();
            }
            if (push_data) {
                push_obj = $.parseJSON(push_data);
                push_obj.quantity = 1;
                push_obj.price = $(elem).find('.full_price .price').text().replace(/[^0-9]/gi, '');
            }

            if ($(elem).hasClass('optional_product_wrapper') || $(elem).hasClass('fastview_add_to_cart')) {
                var optional_wrapper = $(elem);
                push_obj = new Object();
                push_obj.quantity = 1;
                push_obj.name = $(optional_wrapper).find('.item_name').val();
                push_obj.id = $(optional_wrapper).find('.item_id').val();
                push_obj.brand = $(optional_wrapper).find('.brand_name').val();
                push_obj.category = $(optional_wrapper).find('.category_name').val();
                push_obj.price = $(optional_wrapper).find('.first_price').val();
            }
            if (push_obj) {
                ga('ec:addProduct', push_obj);
                ga('ec:setAction', 'add');
                ga('send', 'event', 'UX', 'click', 'add to cart');
            }
        } catch (err) {
        }

        try {
            var push_data;
            if ($('.ecom_products').html()) {
                push_data = $('.ecom_products').html();
            }
            if ($('.ecom_complect').html()) {
                push_data = $('.ecom_complect').html();
            }
            if (push_data) {
                push_obj = $.parseJSON(push_data);
            }
            if ($(elem).hasClass('optional_product_wrapper')) {
                var optional_wrapper = $(elem);
                push_obj.id = $(optional_wrapper).find('.item_id').val();
                push_obj.name = $(optional_wrapper).find('.item_name').val();
                push_obj.brand = $(optional_wrapper).find('.brand_name').val();
                push_obj.category = $(optional_wrapper).find('.category_name').val();
                push_obj.price = $(optional_wrapper).find('.first_price').val();
            }

            if (push_obj) {
                add2_obj = {};
                add2_obj.event = 'AddToCart';
                add2_obj.eventCategory = 'Order';
                add2_obj.eventAction = 'AddToCart';
                add2_obj.eventLabel = push_obj.name;
                if ($('.full_price .price').html()) {
                    add2_obj.eventValue = $('.full_price .price').html().replace(/[^0-9]/gi, "");
                } else {
                    $('.month_label').each(function () {
                        if ($(this).find('.month_count').prop('checked')) {
                            add2_obj.eventValue = $(this).find('.price').html().replace(/[^0-9]/gi, "");
                        }
                    });
                }

                add2_obj.currency = 'RUB';
                add2_obj.content_name = push_obj.name;
                add2_obj.content_type = 'product';
                add2_obj.content_ids = push_obj.id;
                add2_obj.content_category = push_obj.category;
                dataLayer.push(add2_obj);

                if (data.type === 'complect' && data.id == 22) {
                    add2_obj.eventCategory = '';
                    if (reverer) {
                        add2_obj.eventCategory = referer;
                    }
                    add2_obj.eventAction = 'add_to_cart';
                    add2_obj.eventLabel = window.location.href;
                }
            }
        } catch (err) {
        }

        if ($(elem).find('button[type=submit]').hasClass('ya_rentfromitem')) {
            ya_reach_goal('rentfromitem');
        }
        if ($(elem).find('button[type=submit]').hasClass('ya_subscribefromitem')) {
            ya_reach_goal('subscribefromitem');
        }
        if ($(elem).find('button[type=submit]').hasClass('ya_rentcomlexitem')) {
            ya_reach_goal('rentcomlexitem');
        }
    }

    var ajax_obj = {
        url,
        type: 'post',
        beforeSend: function () {
            $(elem).find('.field_wrapper').addClass('nod');
            $(elem).find('.loader_wrapper').removeClass('nod');
        },
        data,
        dataType: 'json',
        complete: function (answer) {
            $(elem).find('.loader_wrapper').addClass('nod');

            if (!answer.responseText) {
                return;
            }
            let res;
            try {
                res = $.parseJSON(answer.responseText)
            } catch (e) {
                res = { status: 'Success' };
            }

            if (res.status === 'Success') {
                if ($(elem).parents('.favorite_item_wrapper').length > 0) {
                    $(elem).parents('.favorite_item_wrapper').find('.favorite_button').click();
                }

                if (res.message) {
                    $(elem).find('.result_wrapper').removeClass('nod');
                }

                ecommEvents();

                if (res.cart_popup) {
                    $('.cart_popup_wrapper').html(res.cart_popup);
                }
                if ($(elem).hasClass('fastcart')) {
                    window.location.href = '/cart/';
                }
                setTimeout(function () {
                    $('.product_fixed_form .in-list').removeClass('nod');
                    $('.product_fixed_form .not-in-list').addClass('no_show');

                    $(elem).find('.in-list').removeClass('nod');
                    $(elem).find('.not-in-list').addClass('no_show');
                    $(elem).find('.result_wrapper').addClass('nod');
                    $(elem).find('.result_wrapper').html('');
                    $(elem).find('.result_wrapper').removeClass('error-color');
                    $(elem).find('.result_wrapper').removeClass('green');
                    $(elem).find('.field_wrapper').removeClass('nod');
                    $(elem).find('.product-simple__mobsection2').css('height', 'auto');
                }, 0);
                // update cart floating block
                get_compact_list();

                if ($(elem).hasClass('js-cart-with-popup') && res.popupCartUrl /*&& width < 768*/) {
                    $(res.popupUrlClass).html(res.popupCartUrl);
                    const iframe = $(res.popupUrlClass).find('iframe');
                    const domainElement = document.querySelector('.popup.popup-fast-order');
                    const token = domainElement.dataset.token;
                    if (token) {
                        iframe.on('load', () => {
                            setTimeout(() => iframe[0].contentWindow.postMessage({ action: 'token', value: token }, '*'), 500);
                        });
                    }
                    $(res.btnUrlClass).click();
                    $('body').addClass('checkout');
                }
                if ($(elem).hasClass('js-cart-with-popup') && res.popupCart && (/*width >= 768 ||*/ !res.popupCartUrl)) {
                    $(res.popupClass).html(res.popupCart);
                    $(res.btnClass).click();
                    const popupContainer = document.querySelector(res.popupClass);
                    addMasks(popupContainer);
                    $('.popup-fast-order__form .js-input-tel').on('input', window.completedFastOrderPhone);
                    $('.popup-fast-order__form .js-input-tel').on('keyup', window.completedFastOrderPhone);
                    $('.popup-fast-order__form .js-input-name').on('keyup', window.completedFastOrderName);
                    $('.popup-fast-order__form .js-input-name').on('keyup', window.completedFastOrderName);
                    $('.popup-fast-order__form button').on('click', (e) => {
                        if ($(e.target).hasClass('js-popup-close')) {
                            return;
                        }
                        e.preventDefault();
                        const isOk = check_form($('.popup-fast-order__form'), 2);
                        if (isOk) {
                            window.location = '/cart/';
                        }
                        return false;
                    });
                    $('.popup-fast-order__option input').on('change', (e) => {
                        const value = e.target.value;
                        const container = $('#datepicker-days-order');
                        const data = {
                            delivery: [moment($(container).find('.date_start').val(), 'DD.MM.YYYY').unix()],
                        };
                        if (value === 'pvz') {
                            data.pickup_pvz = 4;
                        } else if (value === 'courier') {
                            data.variant = [1];
                        } else if (value === 'pos') {
                            data.is_pos = 1;
                            data.pickup_pvz = e.target.dataset.firstPos ?? '';
                        }
                        $.ajax({
                            url: '/cart/update/',
                            type: 'post',
                            data,
                            dataType: 'json',
                            cache: false,
                            async: true,
                        });
                    });
                    const type = $('#datepicker-days-order').data('type');
                    const pickerElem = $('#datepicker-days-order');
                    const obj = {};
                    if ($(pickerElem).is('[data-min-day]')) {
                        const startDate = $(pickerElem).data('min-day');
                        obj.startDate = new Date(startDate);
                    }
                    if ($(pickerElem).is('[data-forbidden-days]')) {
                        const forbiddenDays = $(pickerElem).data('forbidden-days');
                        obj.beforeShowDay = function (t) {
                            const parsedTime = moment(t).format('DD.MM.YYYY');
                            const disabledDates = Object.values(forbiddenDays);
                            const valid = (disabledDates.indexOf(parsedTime) === -1);
                            const _class = '';
                            const _tooltip = valid ? '' : 'В этот день товар занят';
                            return [valid, _class, _tooltip];
                        };
                    }
                    const getDayPrice = (firstDate, time, priceArr) => {
                        const now = moment(firstDate);
                        const datetime = moment(time).startOf('day');
                        const diff = datetime.diff(now, 'days');

                        if (diff < 0) {
                            return '';
                        }
                        if (!priceArr) {
                            return '';
                        }
                        if (diff == 0) {
                            return '&nbsp;';
                        } else if (diff > 0 && diff <= 1) {
                            return priceArr[0];
                        } else if (diff > 1 && diff <= 2) {
                            return priceArr[1];
                        } else {
                            return priceArr[2];
                        }
                    };
                    if ($(pickerElem).data('startday')) {
                        obj.firstDate = moment($(pickerElem).data('startday'),'DD.MM.YYYY').toDate();
                    } else {
                        obj.firstDate = new Date();
                    }

                    obj.firstDate.setHours(0, 0, 0, 0);
                    obj.showDateFilter = function(object, time, date) {
                        let price = '';
                        if ($(pickerElem).data('type') !== 'single') {
                            price = getDayPrice(object.firstDate, time, $(pickerElem).data('prices'));
                        }
                        return '<div class="date-picker-cell">\
                  <span class="date-picker-day">'+date+'</span>\
                  <div class="date-picker-price">'+price+'</div>\
                </div>';
                    }
                    pickerElem.dateRangePicker({
                        autoClose: true,
                        language:'ru',
                        format: 'DD MMM',
                        startOfWeek:'monday',
                        startDate: new Date(),
                        minDays: 3,
                        singleMonth: type === 'single',
                        singleDate: type === 'single',
                        separator: '<i class="datepicker__icon-sep"></i><br>',
                        stickyMonths: true,
                        inline: true,
                        container: $('.popup-fast-order__date'),
                        showTopbar: false,
                        customOpenAnimation: function (cb) {
                            $(this).fadeIn(0, cb);
                        },
                        customCloseAnimation: function (cb) {
                            $(this).fadeOut(0, cb);
                        },
                        getValue: function () {
                            return $(this).find('.datepicker__data').html();
                        },
                        setValue: function (s) {
                            $(this).find('.datepicker__data').html(s);
                        },
                        hoveringTooltip: function(days) {
                            const nights = days - 1;
                            if (nights < 2) {
                                return "Аренда доступна от 2 суток";
                            }
                            return nights + ' суток';
                        },
                        ...obj,
                    }).bind('datepicker-open', function(){
                        $('#datepicker-days-order').addClass('is-open');
                    }).bind('datepicker-closed', function(){
                        $('#datepicker-days-order').removeClass('is-open');
                    }).bind('datepicker-change', function(event, obj) {
                        const container = $('#datepicker-days-order');
                        const end_date = moment(obj.date2).format('DD.MM.YYYY');
                        const start_date = moment(obj.date1).format('DD.MM.YYYY');
                        const data = {
                            item_id: $(container).find('.item_id').val(),
                            date_from: start_date,
                            amount: 1,
                        };
                        if (type === 'range') {
                            data.date_to = end_date;
                        }
                        $.ajax({
                            url: '/cart/update/',
                            type: 'post',
                            data,
                            dataType: 'json',
                            complete: function (answer) {
                                if (!answer.responseText) {
                                    return;
                                }
                                $(container).find('.date_end').val(end_date);
                                $(container).find('.date_start').val(start_date);
                            },
                            cache: false,
                            async: true,
                        });
                    });
                }
            } else {
                if (res.iqos_here_error) {
                    show_popup($('#popup-no-rent-iqos'));
                }
                $(elem).find('.not-in-list').removeClass('nod');
                $(elem).find('.field_wrapper').removeClass('nod');
                if ($(elem).hasClass('js-cart-with-popup') && res.error_type == 'spb') {
                    $('.js-popup-spb-btn').click();
                }
            }
            $('.cart_amount').addClass('nod');
            if (parseInt(res.cart_amount) > 0) {
                $('.cart_amount').html(res.cart_amount).removeClass('nod');
            }

            // с виду это все нужно только в отдельном файле для виджетов
            /*if (data.partner === "mts") {
                try {
                    ga('ec:setAction', 'add');
                    ga('send', 'event', 'UX', 'click', 'mts_step1');

                    var mts_obj = {
                        'event': 'vntArent',
                        'eventCategory': 'arenter',
                        'userAuth': $(elem).find('.is_auth').val(),
                        'eventAction': 'button_click',
                        'eventLabel': 'vzyat_v_arendu',
                        'eventValue': Number(data.month_price),
                        'screenName': document.location.pathname,
                        'eventContent': 'step_1',
                        'eventContext': data.amount,
                        'buttonLocation': 'popup',
                        'actionGroup': 'interactions',
                        'productName': $('.product_name').text(),
                        'productId': data.mts_id
                    };

                    dataLayer.push(mts_obj);
                } catch (err) {
                }
                window.location.href = $(elem).find('.go_to_cart_button').attr('href');
                return;
            }
            if (data.partner === 'kant' || data.partner === 'svyaznoy') {
                try {
                    const periodsByType = {
                        sub_fix_week: () => `${data.amount} нед`,
                        sub: () => `${amount} мес`,
                        arenda: () => {
                            const start = moment(data.date_start, "DD.MM.YYYY");
                            const end = moment(data.date_end, "DD.MM.YYYY");
                            const days = end.diff(start, 'days')
                            return `${days} дн`;
                        }
                    };

                    let eventLabel = data.kant_id;
                    eventLabel = data.partner === 'svyaznoy' ? data.svyaznoy_id : eventLabel;

                    const eventData = {
                        'event': 'arenter',
                        'eventAction': 'Choose_rental_period',
                        'eventLabel': eventLabel, // id товара
                        'eventValue': 0,
                        'productName': $('.product_name').text(), // название товара
                        'rentalPeriod': periodsByType[data.sub_type]() // срок аренды
                    };

                    dataLayer.push(eventData);
                } catch (err) {
                }
                window.location = $(elem).find('.go_to_cart_button').attr('href');
                return;
            }
            if (data.partner === 'muztorg') {
                window.location = $(elem).find('.go_to_cart_button').attr('href');
            }*/


        },
        cache: false,
        async: true,
    };
    if (obj && !obj.no_async) {
        ajax_obj.async = false;
    }
    $.ajax(ajax_obj);

    return false;
}

function get_compact_list()
{
    $.ajax({
        url: '/cart/compact/',
        type: 'post',
        data: {},
        dataType: 'json',
        complete: function (answer) {
            if (!answer.responseText) {
                return;
            }
            try {
                res = $.parseJSON(answer.responseText)
            } catch (e) {
                var res = {};
            }
            try {
                convead('event', 'update_cart', { items: res.products });
            } catch (e) {
            }
        },
        cache: false,
        async: true,
    });
}

function show_upload_preview(elem, files) {
    var id = $(elem).attr('id');
    if (id) {var preview_wrapper=$('#'+id+'_preview');}
    var file = elem.files; // FileList object

    // Loop through the FileList and render image files as thumbnails.
    for (var i = 0, f; f = file[i]; i++) {
        // Only process image files.
        if (!f.type.match('image.*')) {
            alert("Image only please....");
        }
        var reader = new FileReader();
        // Closure to capture the file information.
        var output='';
        reader.onload = (function (theFile) {
            return function (e) {
                $(preview_wrapper).removeClass('nod');

                if (id == 'idea_form_file')
                {
                    output+='<div class="inputbox__preview">';
                    output+=['<img class="inputbox__preview-photo" title="', escape(theFile.name), '" src="', e.target.result, '" />'].join('');
                    output+='<span class="inputbox__preview-filename">'+escape(theFile.name)+'</span>'
                    output+='<span class="inputbox__preview-filename">'+Math.floor(theFile.size/1024)+' Кб</span>';
                    output+='<button class="inputbox__preview-del" type="button" onclick="$(\'.form_file\').val(\'\');$(this).parent().remove();"><svg class="icon icon-del"> <use xlink:href="/assets/images/sprite.svg#del"></use> </svg></button>';
                    output+='</div>';
                    $(preview_wrapper).find('.preview_list').html(output+$(preview_wrapper).find('.preview_list').html());
                }

                if (id == 'avatar_file')
                {
                    output+='<div class="inputbox__preview profile_unload_preview_del">';
                    output+=['<img class="inputbox__preview-photo" title="', escape(theFile.name), '" src="', e.target.result, '" />'].join('');
                    output+='<span class="inputbox__preview-filename">'+escape(theFile.name)+'</span>'
                    output+='<span class="inputbox__preview-filename">'+Math.floor(theFile.size/1024)+' Кб</span>';
                    output+='<button class="inputbox__preview-del" type="button" onclick="$(\'.form_file\').val(\'\');$(this).parent().remove();"><svg class="icon icon-del"> <use xlink:href="/assets/images/sprite.svg#del"></use> </svg></button>';
                    output+='</div>';
                    $(preview_wrapper).find('.preview_list').html(output+$(preview_wrapper).find('.preview_list').html());
                }

            };
        })(f);
        // Read in the image file as a data URL.
        reader.readAsDataURL(f);
    }
    $('.profile_unload_preview_del').on('click', function() {$('.form_file').val('');$(this).parent().remove();});
}

function set_order_value(elem)
{
    if (elem)
    {
        if ($(elem).parents('.order_column_wrapper').find('.order_name').val()) {cookie_name = $(elem).parents('.order_column_wrapper').find('.order_name').val();}
        var desc = getCookie(cookie_name+'_desc');
        var column = getCookie(cookie_name);
        var new_order = $(elem).attr('id');
        window.setCookie(cookie_name, new_order);
        if (!desc) {desc = 'desc';}
        new_desc = desc;
        if (new_order == column)
        {
            var new_desc = 'asc';
            if (desc == 'asc') {new_desc='desc';}
        }

        window.setCookie(cookie_name+'_desc', new_desc);
        window.location.reload();
    }
}

function set_search_date(elem)
{
    if (elem)
    {
        var wrapper = $(elem).parents('.date-range');
        var name = $(wrapper).find('.date_name').val();

        if (name)
        {
            window.setCookie(name+'_date_start', $(wrapper).find('.date_start').val());
            window.setCookie(name+'_date_end', $(wrapper).find('.date_end').val());
            window.location.reload();
        }
    }
}

function set_on_page(elem)
{
    if (elem)
    {
        if ($(elem).parents('.pagination').find('.on_page_name').val()) {cookie_name = $(elem).parents('.pagination').find('.on_page_name').val();}
        window.setCookie(cookie_name, $(elem).html());
        window.location.reload();
    }
}

function change_filter_order(mob = 0)
{
    var catalog_order = getCookie('catalog_order');
    if (mob == 1)
    {
        if (catalog_order == 0) {$('#filter_order').val(1);}
        if (catalog_order == 1) {$('#filter_order').val(2);}
        if (catalog_order == 2) {$('#filter_order').val(0);}
    }
    window.setCookie('catalog_order', $('#filter_order').val());
    window.location.reload();
    //if ($('#filter_order').val() != catalog_order) {window.location.reload();}
    return;
}

function change_filter_category(elem)
{
    if (elem)
    {
        var name=$('#filter_form').find('.search_name').val();
        if (name) {document.cookie=name+'=; path=/';}
        var new_category=$(elem).val();
        var old_category=$('#hidden_filter_category').val();
        if (new_category>0 && new_category!=old_category) {window.location.href='/category_by_id/'+new_category;}
    }

}

function change_filter_brand(elem)
{
    if (elem)
    {
        var name=$('#filter_form').find('.search_name').val();
        if (name) {document.cookie=name+'=; path=/';}
        var new_brand=$(elem).val();
        var old_brand=$('#hidden_filter_brand').val();
        if (new_brand>0 && new_brand!=old_brand) {window.location.href='/brand/'+new_brand;}
    }
}

function select_datepicker(date, datepicker)
{
    var month_list=new Array ('января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря');
    var small_month_list=new Array ('янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек');
    var date_arr=date.split('.');
    var picker_id=$(datepicker).attr('id');


    var wrapper=$('#'+picker_id).parents('.datep_wrapper').find('.datep_show');
    var arr=month_list;
    if ($(wrapper).hasClass('small_month')) {arr=small_month_list;}
    var res=date_arr[0]+' '+arr[date_arr[1]-1];
    if ($(wrapper).hasClass('small_month')) {res+='.';}

    $('#'+picker_id).parents('.datep_wrapper').find('.datep_show').html(res);
    $('#hidden-'+picker_id).val(date);
    $('#'+picker_id).datepicker('option', 'disabled', true);
}


function check_datepicker(elem)
{
    if (elem) {var picker=$(elem).find('.datep_field');}
    if (picker)
    {
        var id=$(picker).attr('id');
        if ($(picker).datepicker('option', 'disabled'))
        {

            $(picker).datepicker('enable');
            $(picker).datepicker('option', 'disabled', false);
            $(picker).focus();
        }
        else
        {
            $(picker).datepicker('disable');
            $(picker).datepicker('option', 'disabled', true);
        }
    }
}

function check_filter_search(elem)
{
    if (elem)
    {
        //if ($(elem).hasClass('is-current')) {$(elem).removeClass('is-current');} else {$(elem).addClass('is-current');}
    }
}

function check_search_field(elem)
{
    if (elem)
    {
        $('.filter-hint').addClass('nod');
        var wrapper = $(elem).parents('.search_item_wrapper');
        var price_wrapper = $(elem).parents('.price_slider_wrapper');
        if ($(wrapper).hasClass('active'))
        {
            $(wrapper).removeClass('active');
            $(wrapper).find('.feature_value').prop('checked', false);
        }
        else
        {
            $(wrapper).addClass('active');
            $(wrapper).find('.feature_value').prop('checked', true);
        }

        //console.log($(input).prop('checked'));
        //if ($(input).prop('checked')) {$(input).prop('checked', false);} else {$(input).prop('checked', true);}
        var search_form = $(elem).parents('form');
        if (search_form)
        {
            if (wrapper) {$(wrapper).find('.filter-hint').removeClass('nod');}
            if (price_wrapper) {$(price_wrapper).find('.filter-hint').removeClass('nod');}
            check_common_search_form($('#'+$(search_form).attr('id')), 0);
        }
    }
}

function del_search_item(elem)
{

    if (elem)
    {
        var id = $(elem).find('.icon-del').attr('id');
        $('.search_field.'+id).click();
    }
}

function clear_search_filter(elem)
{
    if (elem)
    {
        $('.filter-hint').addClass('nod');
        var form = $(elem).parents('form');
        var name=$(form).find('.search_name').val();
        //$(form).find('.filter_info').addClass('nod');
        $(form).find('.filter_result_wrapper').html('');
        $(form).find('.feature_value').prop('checked', false);
        $(form).find('.feature_value').removeAttr('checked');
        $(form).find('.search_item_wrapper').removeClass('active');

        delCookie(name);
        //console.log(document.cookie);
        //window.location.reload();
        check_common_search_form(form, 0);
    }
}

function check_common_search_form(elem, reload)
{
    if (!elem) {
        return false;
    }

    var name = $(elem).find('.search_name').val();
    if (!name) {
        return false;
    }

    var value = '';
    var new_val = [];
    let i = 0;

    $('.common_result_count').html($('.filter_loader .loader_wrapper').html());
    $('.filter_result_wrapper').html('');
    $('.feature_id').each(function () {
        var feature_id = $(this).val();
        var list = $(this).parents('.feature_wrapper').find('.search_item_wrapper');
        if (list.length > 0) {
            var good = 0;
            for (k = 0; k < list.length; k++) {
                var check = list[k];
                if ($(check).hasClass('active')) {
                    if (!new_val[i]) {
                        new_val[i] = 'feature:' + feature_id;
                    }
                    new_val[i] = new_val[i] + ':' + $(list[k]).find('.feature_value').val();
                    good = 1;
                    var name = $(list[k]).find('.feature_value').val();
                    if ($(check).find('.value_descr').val()) {
                        name = $(check).find('.value_descr').val();
                    }

                    var html = '<li class="del_search_item"><span>' + name + '</span><svg class="icon icon-del" id="feature_' + feature_id + '_value_' + $(list[k]).find('.value_id').val() + '"><use xlink:href="/assets/images/sprite.svg#del"></use></svg></li>';
                    $('.filter_result_wrapper').append(html);
                }

            }
            if (good == 1) {
                i++;
            }
        }
    });
    if ($(elem).find('.price_from').val()) {
        new_val[i] = 'feature:price_from:' + $(elem).find('.price_from').val().replace(/[^0-9]/gi, "");
        i++;
    }
    if ($(elem).find('.price_to').val()) {
        new_val[i] = 'feature:price_to:' + $(elem).find('.price_to').val().replace(/[^0-9]/gi, "");
    }

    if (new_val.length > 0) {
        value = new_val.join("|");
        value = value.replace('+', 'pppplus');
        window.setCookie(name, value);
    } else {
        delCookie(name);
    }
    if (reload == 1) {
        window.location.reload();
    }
    const full_html = $('.filter_result_wrapper').html();
    no_async = 0;
    const delayedFn = () => {
        $('.filter_loader').addClass('nod');
        $('.filter_result_wrapper').html(full_html);
        if (full_html) {
            $('.filter_reset_button').removeClass('nod');
        } else {
            $('.filter_reset_button').addClass('nod');
        }
    }
    send_form($(elem), delayedFn);
    //no_async = 0;

    return false;
}

window.check_field = function(elem, kod) {
    var def = '';
    var ready = 0;
    var good = 1;

    if ($(elem).attr('type') == 'radio') {
        ready = 1;
        $(elem).parents('.group_wrapper').find('.result_marker').removeClass('is-error');
        var name = $(elem).attr('name');
        good = 0;

        $(elem).parents('form').find('input[name="' + name + '"]').each(function () {
            if ($(this).prop('checked')) {
                good = 1;
            }
        });
    }

    if ($(elem).attr('type') == 'checkbox') {
        ready = 1;
        $(elem).removeClass('is-error');
        if ($(elem).hasClass('need_field')) {
            if (!$(elem).prop('checked')) {
                good = 0;
            }
        }
    }

    if (ready == 0) {
        if ($(elem).attr('default_value')) {
            def = $(elem).attr('default_value');
        }
        if ($(elem).attr('default')) {
            def = $(elem).attr('default');
        }
        if ($(elem).parent().find('.default').html()) {
            def = $(elem).parent().find('.default').html();
        }
        $(elem).parent().find('.default').addClass('nod');
        if ($(elem).val() == '') {
            good = 0;
        }
    }

    if (good == 0) {
        $(elem).parent().find('.default').removeClass('nod');
        if ($(elem).hasClass('is-error')) {
            $(elem).parent().find('.select-styled').addClass('is-error');
        }
        if ($(elem).hasClass('need_field') && [1,2].includes(kod)) {
            $(elem).addClass('is-error');
            $(elem).parent().find('.select-styled').addClass('is-error');
            $(elem).parents('.group_wrapper').find('.result_marker').addClass('is-error');
            return false;
        }
        return true;
    } else {
        return true;
    }
}

function clear_form(elem)
{
    $(elem).find('.add_field').each(function() {
        if ($(this).hasClass('no_clear')==false) {$(this).val('');}
    });
    check_form(elem);
}


function get_code(rand)
{
    var req = new Object;
    var result;
    if (rand) {req.rand = rand;}
    var ajax_obj = {
        url: '/form/code/',
        type: 'post',
        data: req,
        dataType:'json',
        complete: function(result)
        {
            if (result.responseText)
            {
                try {res = $.parseJSON(result.responseText);}
                catch (err)
                {
                    res = new Object();
                    res.result = 1;
                    res.message = 'Данные отправлены';
                }

                if (res.code) {req.code = res.code;}
            }
        },
        cache: false,
        async: false
    };
    $.ajax(ajax_obj);

    return req.code;
}

function get_values(elem, fields, data)
{
    var arr = new Object;
    if (!data) {var data=new Object;}
    if (elem && fields)
    {
        $(elem).find(fields).each(function()
        {
            good = 1;
            if ($(this).attr('type')=="radio" && !$(this).prop('checked')) {good  = 0;}
            if ($(this).attr('type')=="checkbox" && !$(this).prop('checked')) {good  = 0;}
            if (good == 1)
            {
                if (data[$(this).attr('name')])
                {
                    if (data[$(this).attr('name')] instanceof Array)
                    {
                        data[$(this).attr('name')][data[$(this).attr('name')].length] = $(this).val();
                    }
                    else
                    {
                        var tmp = data[$(this).attr('name')];
                        data[$(this).attr('name')] = new Array;
                        data[$(this).attr('name')][data[$(this).attr('name')].length] = tmp;
                        data[$(this).attr('name')][data[$(this).attr('name')].length] = $(this).val();
                    }
                }
                else {data[$(this).attr('name')]=$(this).val();}
            }
        });
    }
    return data;
}

let currentFormAjax = [];
function send_form(elem, delayedFn = null) {
    if (elem) {
        if ($(elem).hasClass('full_send')) {
            try {
                var data = new FormData(document.getElementById($(elem).attr('id')));
            } catch (err) {
                console.log(err);
            }
        } else {
            var data = get_values(elem, '.add_field');
        }
        if (!data) {
            data = new Object;
        }
        data.from_page = document.location.href;
        data.rand = Math.random();
        data.code = get_code(data.rand);

        var url = $(elem).attr('action');
        if ($(elem).find('.url').val()) {
            url = $(elem).find('.url').val();
        }

        var ajax_obj = {
            url: url,
            type: 'post',
            beforeSend: function () {
                $(elem).find('.result_wrapper').addClass('nod');
                if (!data.no_message) {
                    $(elem).find('.result_wrapper').html('');
                }
                $(elem).find('.result_wrapper').removeClass('error-color');
                $(elem).find('.result_wrapper').removeClass('green');
                $(elem).find('.field_wrapper').addClass('nod');
                $(elem).find('.loader_wrapper').removeClass('nod');
            },
            data: data,
            dataType: 'json',
            complete: function (answer) {

                if (answer.responseText) {
                    let res;
                    try {
                        res = $.parseJSON(answer.responseText);
                    } catch (err) {
                        res = { result: 0 };
                        if (answer.status === 200) {
                            res.result = 1;
                            res.message = 'Данные отправлены';
                        }
                    }

                    if (res.result) {
                        var stop = 0;
                        if (res.redirect) {
                            if (!res.redirect_timeout) {
                                window.location.href = res.redirect;
                                stop = 1;
                            } else {
                                setTimeout(() => window.location.href = res.redirect, res.redirect_timeout);
                            }
                        }

                        if (res.callback) {
                            if (res.nowait) {
                                eval(res.callback);
                            } else {
                                $(elem).find('.result_wrapper').removeClass('nod').removeClass('error-color');
                                if (!$(elem).find('.result_wrapper').hasClass('no_change')) {
                                    $(elem).find('.result_wrapper').addClass('good-color');
                                }
                                if (res.message) {
                                    $(elem).find('.result_wrapper').html(res.message);
                                }
                                $(elem).find('.loader_wrapper').html('').addClass('nod');
                                if (res.wait) {
                                    wt = res.wait;
                                } else {
                                    wt = 3000;
                                }
                                setTimeout(function () {
                                    eval(res.callback);
                                }, wt);
                            }
                            stop = 1;
                        }
                        if (stop == 0) {

                            $(elem).find('.result_wrapper').removeClass('nod').removeClass('error-color').removeClass('good-color');

                            if (res.message) {
                                if (!res.no_change_color && !$(elem).find('.result_wrapper').hasClass('no_change')) {
                                    $(elem).find('.result_wrapper').addClass('good-color');
                                }
                                $(elem).find('.result_wrapper').removeClass('nod');
                                if (!res.no_message && !$(elem).find('.result_wrapper').hasClass('no_change')) {
                                    $(elem).find('.result_wrapper').html(res.message);
                                }
                            }

                            $(elem).find('.loader_wrapper').addClass('nod');

                            if (res.need_clear) {
                                clear_form(elem);
                            }
                            change_captcha_class('symbol_captcha');
                            if (res.hide_result) {
                                setTimeout(function () {
                                    $(elem).find('.result_wrapper').addClass('nod')
                                }, 3000);
                            }

                            if (!res.hide_fields && !$(elem).hasClass('hide_fields')) {
                                setTimeout(function () {
                                    //$(elem).find('.result_wrapper').addClass('nod')
                                    $(elem).find('.field_wrapper').removeClass('nod');
                                    if ($(elem).hasClass('profile_passport_form')) {
                                        $(elem).find('.field_wrapper').addClass('nod');
                                    }
                                }, 3000);
                            }
                            if (res.full_message) {
                                $('.order-passport').html(`
<div class="order-passport">
     <div style="background: url(../../assets/images/check-success.svg) no-repeat center top;background-size: 100px auto;height: 150px;"></div>
    <h1 class="ta-c">${res.full_message}</h1>
</div>
`);
                            }
                        }

                        if (res.good_redirect) {
                            window.location.href = res.good_redirect;
                        }

                        if ($(elem).hasClass('common_search_form')) {
                            if (res.total_items) {
                                $('.common_result_count').html(res.total_items);
                            }
                            if (res.content) {
                                if (!$(elem).hasClass('take_easy')) {
                                    $('.catalog_content').html(res.content);
                                    $('.catalog_content').find('.selectstyle').each(function (i) {
                                        window.update_select_style(this);
                                    });
                                    check_price_slider();
                                }
                            }

                        }
                        if ($(elem).hasClass('order_review_form')) {
                            $(elem).parents('.order-table__order').find('.result_wrapper').removeClass('nod');
                            $(elem).parents('.order-table__order').find('.order-table__review-link').remove();
                            $(elem).parents('.order-table__order').find('.field_wrapper').remove();
                            //$(elem).remove();
                        }

                        if ($(elem).hasClass('profile_passport_form')) {
                            if ($(elem).find('.partner').val() == "mts") {
                                try {
                                    ga('ec:setAction', 'add');
                                    ga('send', 'event', 'UX', 'click', 'mts_step3');

                                } catch {
                                }

                                dataLayer.push({
                                    'event': 'vntArent',
                                    'eventCategory': 'arenter',
                                    'eventAction': 'confirmed',
                                    'eventLabel': 'otpravka_formy',
                                    'eventValue': Number($('.cart_all_sum').text().replace(/[^\d]/gi, '')),
                                    //'screenName': document.location.pathname, // а есть маппинг наших товаров в урл мтс?
                                    'eventContent': 'step_3',
                                    'eventContext': $('.mts_period').val(),
                                    'buttonLocation': null,
                                    'actionGroup': 'conversions',
                                    'productName': $('.product_name').text(),
                                    'productId': $('.mts_id').val(),
                                });
                            }

                            if ($(elem).find('.partner').val() == "kant") {
                                const amount = $('.amount_field').val();
                                const subType = $('.item_sub_type').val();
                                const dateStart = $('.date_start').val();
                                const dateEnd = $('.date_end').val();
                                const periodsByType = {
                                    sub_fix_week: () => `${amount} нед`,
                                    sub: () => `${amount} мес`,
                                    arenda: () => {
                                        const start = moment(dateStart, "DD.MM.YYYY");
                                        const end = moment(dateEnd, "DD.MM.YYYY");
                                        const days = end.diff(start, 'days')
                                        return `${days} дн`;
                                    }
                                };
                                const eventData = {
                                    'event': 'arenter',
                                    'eventAction': 'Submit_passport_form',
                                    'eventLabel': $('.kant_product_id').val(), // id товара
                                    'eventValue': 0,
                                    'productName': $('.product_name').text(), // название товара
                                    'rentalPeriod': periodsByType[subType]() // срок аренды
                                };

                                dataLayer.push(eventData);
                            }

                            if ($(elem).find('.order_item_info').length > 0) {
                                $(elem).find('.order_item_info').each(function () {
                                    try {
                                        ga("ec:addProduct", $(this).html());
                                        ga("ec:setAction", "checkout", { "step": "passport data" });
                                        ga('send', 'event', 'UX', 'click', 'passport data');
                                        //ga("send", "pageview");
                                    } catch (e) {
                                    }
                                });
                            }


                            var all_days = 0;
                            if ($(elem).find('.all_days').val()) {
                                all_days = $(elem).find('.all_days').val();
                            }
                            var all_price = 0;

                            if ($(elem).find('.all_price').val()) {
                                all_price = $(elem).find('.all_price').val();
                            }

                            try {
                                ya_reach_goal('PassportData');

                                var push_obj2 = new Object;
                                push_obj2.event = 'Checkout';
                                push_obj2.eventCategory = 'Order';
                                push_obj2.eventAction = 'Checkout';
                                push_obj2.eventLabel = all_days;
                                push_obj2.eventValue = all_price;
                                push_obj2.currency = 'RUB';
                                push_obj.paymentType = 'Cart';
                                if ($(elem).find('.order_payment_type_id').val() == 1) {
                                    push_obj.paymentType = 'Delivery';
                                }
                                if ($(elem).find('.order_bonus_code').val()) {
                                    push_obj.promocode = $(elem).find('.order_bonus_code').val();
                                } else {
                                    push_obj.promocode = '';
                                }
                                dataLayer.push(push_obj2);

                            } catch (err) {
                            }


                            var order_id = $(elem).find('.order_id').val();

                            var url = '/cart/order/' + order_id + '/';
                            if (data.partner == 'muztorg') {
                                url = '/cart/order/' + order_id + '/?partner=muztorg&after_scoring=1';
                                if (data.h) {
                                    url += '&h=' + data.h;
                                }
                                if (data.user_token) {
                                    url += '&user_token=' + data.user_token;
                                }
                            }
                            if (data.partner == 'mts') {
                                url = '/cart/order/' + order_id + '/?partner=mts&after_scoring=1';
                                if (data.h) {
                                    url += '&h=' + data.h;
                                }
                                if (data.user_token) {
                                    url += '&user_token=' + data.user_token;
                                }
                            }
                            if (data.partner == 'svyaznoy') {
                                url = '/cart/order/' + order_id + '/?partner=svyaznoy&after_scoring=1';
                                if (data.h) {
                                    url += '&h=' + data.h;
                                }
                                if (data.user_token) {
                                    url += '&user_token=' + data.user_token;
                                }
                            }
                            if (data.partner == 'kant') {
                                url = '/cart/order/' + order_id + '/?partner=kant&after_scoring=1';
                                if (data.h) {
                                    url += '&h=' + data.h;
                                }
                                if (data.user_token) {
                                    url += '&user_token=' + data.user_token;
                                }
                            }
                            if (data.partner == 'skifmusic') {
                                url = '/cart/order/' + order_id + '/?partner=skifmusic&after_scoring=1';
                                if (data.h) {
                                    url += '&h=' + data.h;
                                }
                                if (data.user_token) {
                                    url += '&user_token=' + data.user_token;
                                }
                            }
                            if (order_id) {
                                //console.log(url);return false;
                                window.setCookie('after_scoring', 1);
                                window.location.href = url;
                                //setTimeout(function() {window.location.href = url;}, 2000);
                            }
                        }
                    }
                    if (!res.result) {
                        const errorMessageArr = [];
                        $(elem).find('.loader_wrapper').addClass('nod');
                        $(elem).find('.result_wrapper').removeClass('nod').removeClass('good-color').addClass('error-color');
                        if (res.error) {
                            if ($(elem).hasClass('profile_passport_form')) {
                                if (res.error_message) {
                                    const arr = res.error_message.split(':');
                                    if (arr[1]) {
                                        res.error_message = arr[1];
                                    }
                                    if (arr[0]) {
                                        $(elem).find('.' + arr[0] + '_field').addClass('is-error');
                                    }

                                }
                            }

                            for (let i = 0; i < res.error.length; i++) {
                                if (res.error[i].field !== 'hidden') {
                                    if (res.error[i].error) {
                                        errorMessageArr.push(res.error[i].error);
                                    }


                                    $(elem).find('input[name="' + res.error[i].field + '"]').addClass('is-error');
                                    $(elem).find('error_' + res.error[i].field).addClass('is-error');
                                    if (res.error[i].field === 'symbol') {
                                        $(elem).find('input[name=' + res.error[i].field + ']').val('');
                                        change_captcha_class('symbol_captcha');
                                    }
                                }
                            }

                            error_message = errorMessageArr.join('<br>');
                        }
                        error_message = res.error_message ?? error_message ?? '';
                        check_form(elem);
//if ($(elem).hasClass('profile_passport_form')) {console.log(answer.responseText);return false;}
                        go_to_error();
                        if ($(elem).find('.partner').val() === 'mts') {
                            dataLayer.push({
                                'event': 'vntArent',
                                'eventCategory': 'arenter',
                                'eventAction': 'rejected',
                                'eventLabel': 'otpravka_formy',
                                'eventValue': Number($('.cart_all_sum').text().replace(/[^\d]/gi, '')),
                                //'screenName': document.location.pathname, // а есть маппинг наших товаров в урл мтс?
                                'eventContent': 'step_3',
                                'eventContext': $('.mts_period').val(),
                                'buttonLocation': null,
                                'actionGroup': 'interactions',
                                'productName': $('.product_name').text(),
                                'productId': $('.mts_id').val(),
                            });
                        }

                        $(elem).find('.result_wrapper').removeClass('nod').addClass('error-color').html(error_message);
                        if (!res.hide_fields) {
                            setTimeout(function () {
                                $(elem).find('.field_wrapper').removeClass('nod');
                            }, 300);

                        }
                    }
                    if (delayedFn) {
                        delayedFn();
                    }
                }
            },
            cache: false,
            async: true
        };
        if (no_async == 1) {
            ajax_obj.async = false;
        }
        if ($(elem).hasClass('full_send')) {
            try {
                ajax_obj.processData = false;
                ajax_obj.contentType = false;
            } catch (err) {
            }
        }
        if (currentFormAjax[elem]) {
            currentFormAjax[elem].abort();
        }
        currentFormAjax[elem] = $.ajax(ajax_obj);
    }
    return false;
}

window.ready_field = function(elem) {
    $(elem).removeClass('is-error');
    $(elem).parent().find('.select-styled').removeClass('is-error');
    $(elem).parent().find('.default').addClass('nod');
    $(elem).parents('.group_wrapper').find('.result_marker').removeClass('is-error');
    $(elem).parents('.date-wrapper').find('.is-error').removeClass('is-error');
}

function go_to_error(elem) {
    const headerHeight = $('.header').outerHeight();
    var offset = $('.is-error:visible').offset();
    if (elem) {
        offset = $(elem).find('.is-error:visible').offset();
    }

    if (offset) {
        if (offset.top > 0) {
            $("body, html").animate({ "scrollTop": offset.top - headerHeight - 1 }, 'slow');
        }
    }
}

function check_form(elem, kod) {
    var result = true;
    $(elem).find('.check_field').each(function () {
        if (!check_field(this, kod)) {
            result = false;
        }
    });

    if ($(elem).hasClass('profile_passport_form') && kod == 1) {
        if (!$(elem).find('.error_pas_ser').length || !$(elem).find('.error_pas_num').length) {
            if ($(elem).hasClass('with_pas')) {
                result = false;
            }
        } else {
            if ($(elem).find('.error_pas_ser').val().length < 4 && $(elem).find('.error_pas_ser').hasClass('add_field')) {
                $(elem).find('.error_pas_ser').addClass('is-error');
                result = false;
            }
            if ($(elem).find('.error_pas_num').val().length < 6 && $(elem).find('.error_pas_num').hasClass('add_field')) {
                $(elem).find('.error_pas_num').addClass('is-error');
                result = false;
            }
        }
    }
    if ($(elem).hasClass('cart_list_form') && $(elem).find('.company_check').val() == 1) {
        if (!check_field($(elem).find('.inn'), kod)) {
            result = false;
        }
        if (!check_field($(elem).find('.kpp'), kod)) {
            result = false;
        }
        if (!check_field($(elem).find('.ogrn'), kod)) {
            result = false;
        }
        if (!check_field($(elem).find('.ur_address'), kod)) {
            result = false;
        }
    }
    if (!result) {
        go_to_error(elem);
        return result;
    }
    if (kod !== 1) {
        return result;
    }
    if ($(elem).hasClass('cloud_crypto_pay')) {
        return get_cloud_cryptogram(elem);
    }
    if ($(elem).hasClass('cloud_token_pay')) {
        return send_cloud_token_pay(elem);
    }

    if (($(elem).hasClass('subscribe_form_city') || $(elem).hasClass('subscribe_form_footer'))) {
        var mpush = {
            event: 'Arenter',
            eventCategory: 'Subscribe',
            eventAction: $(elem).hasClass('subscribe_form_footer') ? 'Footer' : 'Header',
            eventLabel: document.location.href,
        };
        dataLayer.push(mpush);
    }

    if (($(elem).attr('id') == 'common_sendmail_form' || $(elem).attr('id') == 'common_callback_form')) {
        const mpush = {
            event: 'Arenter',
            eventCategory: 'Contact',
            eventAction: $(elem).attr('id') === 'common_callback_form' ? 'Заказать звонок' : 'Написать сообщение',
            eventLabel: document.location.href,
        };
        dataLayer.push(mpush);
    }

    if (($(elem).attr('id') == 'review_form')) {
        const mpush = {
            event: 'Arenter',
            eventCategory: 'Review',
            eventAction: document.location.href,
            eventLabel: $(elem).find('#set-rate').val(),
        };
        dataLayer.push(mpush);
    }

    if ($(elem).hasClass('cart_list_form') && $(elem).hasClass('before_order')) {
        var data = {};

        $(elem).find('.reg_field').each(function () {
            data[$(this).attr('name')] = $(this).val();
            if ($(this).attr('name') === 'profile[no_patronymic]') {
                data[$(this).attr('name')] = $(this).is(':checked') ? $(this).val() : 0;
            }
        });

        if ($(elem).find('.company_check').val() == 1) {
            data.is_company = 1;
            $(elem).find('.company_field_wrapper').find('.add_field').each(function () {
                data[$(this).attr('name')] = $(this).val();
            });
        }

        if ($(elem).find('input[name=agreed]').prop('checked')) {
            data['profile[agreed]'] = 1;
        }
        data['partner'] = $(elem).find('.partner').val();
        data['h'] = $(elem).find('.cart_token').val();
        data['user_token'] = $(elem).find('.user_token').val();

        if ($(elem).find('.partner').val() === 'kant') {
            data['item_sub_type'] = $(elem).find('.item_sub_type').val();
        }

        $(elem).find('.field_wrapper').addClass('nod');
        $(elem).find('.loader_wrapper').removeClass('nod');
        var ajax_obj = {
            url: '/cart/register/',
            type: 'post',
            data: data,
            dataType: 'json',
            complete: (answer) => {
                if (!answer.responseText) {
                    return;
                }
                let res;
                try {
                    res = $.parseJSON(answer.responseText);
                } catch (err) {
                    res = { error: 1 };
                }

                if (res.contact_html) {
                    $(elem).find('.contact_html').html(res.contact_html);
                }
                if (res.error) {
                    $(elem).find('.field_wrapper').removeClass('nod');
                    $(elem).find('.loader_wrapper').addClass('nod');
                    go_to_error(elem);
                    if ($(elem).find('.partner').val() === 'mts') {
                        dataLayer.push({
                            'event': 'vntArent',
                            'eventCategory': 'arenter',
                            'eventAction': 'rejected',
                            'eventLabel': 'otpravka_formy',
                            'eventValue': Number($('.cart_all_sum').text().replace(/[^\d]/gi, '')),
                            //'screenName': document.location.pathname, // а есть маппинг наших товаров в урл мтс?
                            'eventContent': 'step_2',
                            'eventContext': $('.amount_field').val(),
                            'buttonLocation': null,
                            'actionGroup': 'interactions',
                            'productName': $('.product_name').text(),
                            'productId': $('.mts_product_id').val()
                        });
                    }
                    $('body').trigger('cart.register.complete', [elem, answer])
                    return;
                }
                if (res.user_token) {
                    $('.user_token').val(res.user_token);
                }
                if ($(elem).hasClass('cart_list_form')) {
                    if ($(elem).find('.partner').val() === 'mts') {
                        try {
                            ga('ec:setAction', 'add');
                            ga('send', 'event', 'UX', 'click', 'mts_step2');
                        } catch (err) {
                        }

                        dataLayer.push({
                            'event': 'vntArent',
                            'eventCategory': 'arenter',
                            'eventAction': 'confirmed',
                            'eventLabel': 'otpravka_formy',
                            'eventValue': Number($('.cart_all_sum').text().replace(/[^\d]/gi, '')),
                            //'screenName': document.location.pathname, // а есть маппинг наших товаров в урл мтс?
                            'eventContent': 'step_2',
                            'eventContext': $('.amount_field').val(),
                            'buttonLocation': null,
                            'actionGroup': 'conversions',
                            'productName': $('.product_name').text(),
                            'productId': $('.mts_product_id').val()
                        });
                    }
                    if ($(elem).find('.partner').val() === "kant") {
                        const amount = $('.amount_field').val();
                        const subType = $('.item_sub_type').val();
                        const dateStart = $('.date_start').val();
                        const dateEnd = $('.date_end').val();
                        const periodsByType = {
                            sub_fix_week: () => `${amount} нед`,
                            sub: () => `${amount} мес`,
                            arenda: () => {
                                const start = moment(dateStart, "DD.MM.YYYY");
                                const end = moment(dateEnd, "DD.MM.YYYY");
                                const days = end.diff(start, 'days')
                                return `${days} дн`;
                            }
                        };
                        const eventData = {
                            'event': 'arenter',
                            'eventAction': 'Submit_checkout_form',
                            'eventLabel': $('.kant_product_id').val(), // id товара
                            'eventValue': 0,
                            'productName': $('.product_name').text(), // название товара
                            'rentalPeriod': periodsByType[subType]() // срок аренды
                        };

                        dataLayer.push(eventData);
                    }

                    try {
                        const date = new Date();
                        const id = date.getFullYear() + '.' + date.getMonth() + '.' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();

                        const order_obj = {};
                        order_obj.ecommerce = {};
                        order_obj.ecommerce.currencyCode = "RUB";
                        order_obj.ecommerce.purchase = {};
                        order_obj.ecommerce.purchase.actionField = {};
                        order_obj.ecommerce.purchase.actionField.goal_id = 43717303;
                        order_obj.ecommerce.purchase.actionField.id = 'Arenter ' + id;
                        order_obj.ecommerce.purchase.products = [];
                        let i = 0;
                        $(elem).find('.cart_item_list').each(function () {
                            order_obj.ecommerce.purchase.products[i] = get_ecom_cart_product(this);
                            i++;
                        });
                        ya_dataLayer.push(order_obj);
                        //console.log(ya_dataLayer);
                    } catch (err) {
                    }

                    var price = 0;
                    var days = 0;
                    var day = 0;
                    $('.cart_item_list').each(function () {
                        if ($(this).find('.products_sum_format').html()) {
                            price += parseInt($(this).find('.products_sum_format').html().replace(/[^0-9]/gi, ""));
                        }
                        var type = $(this).find('.item_type').val();
                        var sub_type = $(this).find('.item_sub_type').val();
                        if (type == 'arenda' || type == 'complect') {
                            var end = moment($(this).find('.date_end').val(), "DD.MM.YYYY");
                            if (sub_type != 'sub') {
                                var start = moment($(this).find('.date_start').val(), "DD.MM.YYYY");
                                day = end.diff(start, 'days')
                            } else {
                                day += $(this).find('.amount_field') * 30;
                            }
                        }
                        if (type == 'sub') {
                            day += $(this).find('.amount_field') * 30;
                        }
                        days += day;

                    });

                    try {

                        var push_obj = {};
                        push_obj.event = 'InitiateCheckout';
                        push_obj.eventCategory = 'Order';
                        push_obj.eventAction = 'InitiateCheckout';


                        push_obj.eventLabel = days;
                        push_obj.eventValue = price;
                        //push_obj.currency = 'RUB';
                        push_obj.paymentType = 'Cart';

                        $(elem).find('.payment_type').each(function () {
                            if ($(this).prop('checked') && $(this).val() == 1) {
                                push_obj.paymentType = 'Delivery';
                            }
                        });
                        if ($(elem).find('.promocode_field').val()) {
                            push_obj.promocode = $(elem).find('.promocode_field').val();
                        } else {
                            push_obj.promocode = '';
                        }
                        // Непонятно, что писать
                        // push_obj.content_name = '';
                        // push_obj.content_category = ''
                        // push_obj.content_ids = '{{Идентификатор продукта}}';
                        //push_obj.num_items = $('.cart_item_list').length;
                        dataLayer.push(push_obj);

                        var push_obj2 = {};
                        push_obj2.event = 'Purchase';
                        push_obj2.eventCategory = 'Order';
                        push_obj2.eventAction = 'Purchase';
                        push_obj2.eventLabel = days;
                        push_obj2.eventValue = price;
                        push_obj2.currency = 'RUB';
                        push_obj.paymentType = 'Cart';

                        $(elem).find('.payment_type').each(function () {
                            if ($(this).prop('checked') && $(this).val() == 1) {
                                push_obj2.paymentType = 'Delivery';
                            }
                        });
                        if ($(elem).find('.promocode_field').val()) {
                            push_obj.promocode = $(elem).find('.promocode_field').val();
                        } else {
                            push_obj.promocode = '';
                        }
                        //dataLayer.push(push_obj2);

                    } catch (err) {
                        console.log(err);
                    }

                    try {
                        var fbqar = {};
                        fbqar.contents = [];
                        fbqar.content_type = 'product';
                        fbqar.value = price;
                        fbqar.currency = 'RUB';
                        let num = 0;

                        $('.cart_item_list').each(function () {
                            var tmp = {};
                            tmp.id = $(this).find('.product_id').val();
                            tmp.quantity = $(this).find('.amount_field').val();
                            tmp.item_price = $(this).find('.sum_field').val();
                            fbqar.contents[num] = tmp;
                            num++;
                        });

                        fbq('track', 'Purchase', fbqar);
                    } catch (err) {
                    }

                    result = ya_reach_goal('orderfromcart');

                    try {
                        var all_cart_price = 0;
                        let num = 1;
                        $('.cart_item_list').each(function () {
                            gtag('event', 'page_view', {
                                'send_to': 'AW-784521757',
                                'dynx_itemid': $(this).find('.product_id').val(), // заменить на id товара
                                'dynx_pagetype': 'conversionintent',
                                'dynx_totalvalue': $(this).find('.sum_field').val() // заменить на стоимость товара
                            });

                            var tmp = {};
                            tmp.id = $(this).find('.product_id').val();
                            tmp.name = $(this).find('.order-list__i-name').text();
                            tmp.quantity = $(this).find('.amount_field').val();
                            tmp.price = $(this).find('.sum_field').val();
                            tmp.category = $(this).find('.product_full_category').val();
                            tmp.brand = $(this).find('.product_brand').val();
                            tmp.position = num;
                            all_cart_price += parseInt($(this).find('.sum_field').val());
                            num++;

                            ga("ec:addProduct", tmp);
                        });
                        ga("ec:setAction", "checkout", {
                            "step": "order step 1",
                            'value': all_cart_price
                        });
                        //ga("ec:setAction", "purchase");
                        ga('send', 'event', 'UX', 'click', 'order step 1');
                        ga("send", "pageview");
                        //result = false;
                    } catch (err) {
                        console.log(err);
                    }
                    $(elem).removeClass('before_order');
                    if ($(elem).data('registered') != 1) {
                        $(elem).data('registered', 1);
                        $(elem).submit();
                    }
                }
                $('body').trigger('cart.register.complete', [elem, answer])
            },
            cache: false
        };
        $.ajax(ajax_obj);
        return false;
    }

    if ($(elem).hasClass('ajax_form')) {
        result = false;
        if (!$(elem).hasClass('no_send_form')) {
            send_form(elem);
        }
    }
    if ($(elem).hasClass('no_send_form')) {
        result = false;
    }

    return result;
}

function blur_field(element)
{
    if (element)
    {
        if ($(element).val()=='') {$(element).val($(element).attr('default_value'));}
    }
}

function focus_field(element)
{
    if (element)
    {
        $(element).removeClass('is-error').removeClass('light_gray');
        if ($(element).val()==$(element).attr('default_value')) {$(element).val('');}
    }
}

function get_scroll(){
    if(window.scrollY==undefined){
        return parseInt(document.body.scrollTop);
    }
    return parseInt(window.scrollY);
}

function get_scroll_x(){
    if(window.scrollX==undefined){
        return parseInt(document.body.scrollLeft);
    }
    return parseInt(window.scrollX);
}

function set_scroll(a){
    if(window.scrollY==undefined){
        document.body.scrollTop=a;
    }
    else {
        window.scrollY=a;}
}

function set_scroll_x(a){

    if(window.scrollX==undefined){

        document.body.Left=a;alert(document.body.Left);
    }
    else {
        window.scrollX=a;}
}

function transkeybord(text, direction)
{
    var cyr = [
        'а','б','в','г','д','е','ж','з','и','й','к','л','м','н','о','п',
        'р','с','т','у','ф','х','ц','ч','ш','щ','ъ','ы','ь','э','ю','я',
        'А','Б','В','Г','Д','Е','Ж','З','И','Й','К','Л','М','Н','О','П',
        'Р','С','Т','У','Ф','Х','Ц','Ч','Ш','Щ','Ъ','Ы','Ь','Э','Ю','Я'
    ];

    lat = [
        'f',',','d','u','l','t',';','p','b','q','r','k','v','y','j','g',
        'h','c','n','e','a','[','w','x','i','o',']','s','m','\'','.', 'z',
        'F','<','D','U','L','T',':','P','B','Q','R','K','V','Y','J','G',
        'H','C','N','E','A','{','W','X','I','O','}','S','M','"','>', 'Z'
    ];

    var from = lat;
    var to = cyr;

    if (direction)
    {
        from = cyr;
        to = lat;
    }

    for (i = 0; i < from.length; i++)
    {

        text = text.replace(from[i], to[i]);
    }

    return text;
}

function only_rus_elem(elem)
{
    var del_count=0;
    var pos=getCaretPos(elem);
    setCaretPos(elem,pos);
    var res='';
    res = $(elem).val();
    new_res = res;
    if ($(elem).hasClass('transkeybord')) {new_res = transkeybord(new_res);}
    new_res = new_res.replace(/[^а-яА-Я0-9\s]/gi, "");
    if (new_res!=res) {$(elem).val(new_res);del_count=res.length-new_res.length;}
    pos-=del_count;

    if (pos<0) {pos=0;}
    setCaretPos(elem,pos);

    return pos;
}

function only_digit_elem(elem)
{
    var del_count=0;
    var pos=getCaretPos(elem);
    setCaretPos(elem,pos);
    var res='';
    res = $(elem).val();
    new_res = res.replace(/[^0-9]/gi, "");
    if (new_res!=res) {$(elem).val(new_res);del_count=res.length-new_res.length;}
    pos-=del_count;

    if (pos<0) {pos=0;}
    setCaretPos(elem,pos);

    return pos;
}

function only_digit(a)
{

    if (document.getElementById(a).value)
    {
        var del_count=0;
        var pos=getCaretPos(document.getElementById(a));
        setCaretPos(document.getElementById(a),pos);
        var res='';
        res=document.getElementById(a).value.replace(/[^0-9]/gi, "");
        if (document.getElementById(a).value!=res) {document.getElementById(a).value=res;del_count=res.length-document.getElementById(a).value.length;}
        pos-=del_count;

        if (pos<0) {pos=0;}
        setCaretPos(document.getElementById(a),pos);
    }
    return pos;
}

function only_digit2(a)
{


    if (document.getElementById(a).value)
    {
        var del_count=0;
        var pos=getCaretPos(document.getElementById(a));
        setCaretPos(document.getElementById(a),pos);
        var res='';
        res=document.getElementById(a).value.replace(/[^0-9\s-()+]/gi, "");
        if (document.getElementById(a).value!=res) {document.getElementById(a).value=res;del_count=res.length-document.getElementById(a).value.length;}
        pos-=del_count;

        if (pos<0) {pos=0;}
        setCaretPos(document.getElementById(a),pos);
    }
    return pos;
}

function only_digit3(a)
{
    if (document.getElementById(a).value)
    {
        var del_count=0;
        var pos=getCaretPos(document.getElementById(a));
        setCaretPos(document.getElementById(a),pos);
        var res='';
        res=document.getElementById(a).value.replace(",", ".");
        res=res.replace(/[^0-9.-]/gi, "");
        if (document.getElementById(a).value!=res) {document.getElementById(a).value=res;del_count=res.length-document.getElementById(a).value.length;}
        pos-=del_count;

        if (pos<0) {pos=0;}
        setCaretPos(document.getElementById(a),pos);
    }
    return pos;
}

function only_letter(a)
{

    if (document.getElementById(a).value)
    {
        var del_count=0;
        var pos=getCaretPos(document.getElementById(a));
        setCaretPos(document.getElementById(a),pos);
        var res='';
        res=document.getElementById(a).value.replace(/[^a-zа-я]/gi, "");
        if (document.getElementById(a).value!=res) {document.getElementById(a).value=res;del_count=res.length-document.getElementById(a).value.length;}
        pos-=del_count;

        if (pos<0) {pos=0;}
        setCaretPos(document.getElementById(a),pos);
    }

    return pos;
}

function prepareNumber(n)
{
    var s = Number(n).toFixed(12);
    s = s.substr(0, s.length - 13);
    for (var i = s.length - 3, j = n < 0 ? 1 : 0; i > j; i -= 3) s = s.substr(0, i) + " " + s.substr(i);
    return s;
}

function check_field_length(len, a)
{
    len=parseInt(len);
    if (document.getElementById(a) && len>0)
    {
        var pos=getCaretPos(document.getElementById(a));
        if (!len) {len=200;}

        var text=$('#'+a).val();

        if (text.length>len)
        {
            text=text.substr(0,len);
            $('#'+a).val(text);
            setCaretPos(document.getElementById(a),pos);

        }
        else
        {

        }

        var more=len - text.length;
        $('#'+a+'_length').text(more);
    }
}

function setCaretPos(obj, pos)
{
    if (obj.createTextRange)
    {
        // IE
        var range = obj.createTextRange();
        range.collapse(true);
        range.moveEnd('character', pos);
        range.moveStart('character', pos);
        range.select();
    }
    else if (obj.selectionEnd)
    {
        // Gecko
        obj.selectionEnd = pos;
    }



    return;
}

function getCaretPos(obj)
{
    obj.focus();

    if(obj.selectionStart) return obj.selectionStart;//Gecko
    else if (document.selection)//IE
    {
        var selection = document.selection.createRange().getBookmark();
        var selection2 = obj.createTextRange();
        selection2.moveToBookmark( selection );
        var before = obj.createTextRange();
        before.setEndPoint('EndToStart', selection2);
        return before.text.length;


        //return sel.offsetLeft;

    }

    return 0;
}

function getCookie(name) {
    var cookie = " " + document.cookie;
    var search = " " + name + "=";
    var setStr = null;
    var offset = 0;
    var end = 0;
    if (cookie.length > 0) {
        offset = cookie.indexOf(search);
        if (offset != -1) {
            offset += search.length;
            end = cookie.indexOf(";", offset)
            if (end == -1) {
                end = cookie.length;
            }
            setStr = unescape(cookie.substring(offset, end));
        }
    }
    return(setStr);
}

window.setCookie=function(name, value, no_expires) {
    var today = new Date();
    var expiration_past = new Date(today.getTime() + 100*365 * 24 * 60 * 60 * 1000);
    var cookie = name + '='+ value +'; path=/;';
    if (!no_expires) {cookie += ' expires=' + expiration_past.toGMTString()+';';}
    document.cookie = cookie;
}

function delCookie(name) {
    var today = new Date();
    var expiration_past = new Date(today.getTime() - 100*365 * 24 * 60 * 60 * 1000);  // 1 год назад
    document.cookie = name + '=delete; path=/; expires=' + expiration_past.toGMTString();
}



function change_captcha(a)
{
    if (document.getElementById(a)) {
        $('.'+a+'_noload').addClass('nod');
        $('.'+a+'_load').removeClass('nod');
        var now = new Date().getTime();
        var src=$('#'+a).attr('src');

        arr=src.split('?');


        src=arr[0]+'?'+now;

        img = new Image();
        img.src=src;
        img.onload=function()
        {
            $('#'+a).attr('src',src);
            $('.'+a+'_load').addClass('nod');
            $('.'+a+'_noload').removeClass('nod');

        }
    }
}

function change_captcha_class(a)
{
    $('.'+a+'_noload').addClass('nod');
    $('.'+a+'_load').removeClass('nod');
    var now = new Date().getTime();
    var src=$('.'+a).attr('src');
    if (src)
    {
        arr=src.split('?');
        src=arr[0]+'?'+now;
        img = new Image();
        img.src=src;
        img.onload=function()
        {
            $('.'+a).attr('src',src);
            $('.'+a+'_load').addClass('nod');
            $('.'+a+'_noload').removeClass('nod');

        }
    }
}


function AddToBookmark(url, title)
{

    if (!title) { var title = window.document.title; }
    if (!url) {var url = window.document.location; }

    try {
        // Internet Explorer
        window.external.AddFavorite(url, title);
    }
    catch (e) {
        try {
            // Mozilla
            window.sidebar.addPanel(title, url, "");
        }
        catch (e) {
            // Opera
            if (typeof(opera)=="object") {
                a.rel="sidebar";
                a.title=title;
                a.url=url;
                a.href=url;
                return true;
            }
            else {
                // Unknown
                alert('Нажмите Ctrl-D чтобы добавить страницу в закладки');
            }
        }
    }

    return false;
}

function getBrowserInfo() {
    var t,v = undefined;

    if (window.chrome) t = 'Chrome';
    else if (window.opera) t = 'Opera';
    else if (document.all) {
        t = 'IE';
        var nv = navigator.appVersion;
        var s = nv.indexOf('MSIE')+5;
        v = nv.substring(s,s+1);
    }
    else if (navigator.appName) t = 'Netscape';

    return {type:t,version:v};
}

function bookmark(a, title, url) {
    if (!title) {title=window.document.title; }
    if (!url) {url=indow.document.location; }

    var b = getBrowserInfo();
    alert(b.type);
    if (b.type == 'IE' && 8 >= b.version && b.version >= 4) window.external.AddFavorite(url,title);
    else if (b.type == 'Opera') {
        a.href = url;
        a.rel = "sidebar";
        a.title = url+','+title;
        return true;
    }
    else if (b.type == "Netscape") window.sidebar.addPanel(title,url,"");
    else alert("Нажмите CTRL-D, чтобы добавить страницу в закладки.");
    return false;
}


window.update_select_style = function(elem)
{
    if (elem)
    {
        if (!$(elem).hasClass('select-hidden'))
        {

            var $this = $(elem), numberOfOptions = $(elem).children('option').length;

            $this.addClass('select-hidden');
            $this.wrap('<div class="select"></div>');
            $this.after('<div class="select-styled"><span></span></div>');

            var $styledSelect = $this.next('div.select-styled');
            $this.next('div.select-styled').find('span').text($this.children('option').eq(0).text());

            var $list = $('<ul />', {
                'class': 'select-options'
            }).insertAfter($styledSelect).wrap('<div class="select-options-wrap"></div>');

            for (var i = 0; i < numberOfOptions; i++) {
                $('<li />', {
                    text: $this.children('option').eq(i).text(),
                    rel: $this.children('option').eq(i).val()
                }).appendTo($list);
            }

            var $listItems = $list.children('li');

            $styledSelect.click(function(e) {
                e.stopPropagation();
                $('div.select-styled.active').not(this).each(function(){
                    $(this).removeClass('active');
                });
                $(this).toggleClass('active');
                if($(this).hasClass('active'))
                    $(this).next('.select-options-wrap').find('.select-options').jScrollPane();
                $('.js-selectbox-toggle').closest('.selectbox').removeClass('is-open');
            });

            $listItems.click(function(e) {
                e.stopPropagation();
                $(this).siblings().removeClass('is-selected');
                $(this).addClass('is-selected');
                $styledSelect.find('span').text($(this).text());
                $styledSelect.removeClass('active');
                $this.val($(this).attr('rel'));
                //console.log($this.val());
            });

            $list.find('li').eq($this.prop('selectedIndex')).click();

            $(document).click(function() {
                $styledSelect.removeClass('active');
            });
            set_select_trigger(elem);
        }


    }



}

function number_format(number, decimals, dec_point, thousands_sep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

function set_select_trigger(elem)
{
    if (elem)
    {
        $(elem).parents('.select').find('.select-options li').each(function() {
            $(this).on('click', function() {$(elem).trigger('change')});
        });
    }
}

